(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Backtrace"] = factory();
	else
		root["Backtrace"] = factory();
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 1345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceBrowserRequestHandler = void 0;
const sdk_core_1 = __webpack_require__(2863);
class BacktraceBrowserRequestHandler {
    constructor(_options) {
        var _a;
        this._options = _options;
        this.UPLOAD_FILE_NAME = 'upload_file';
        this.JSON_HEADERS = {
            'Content-type': 'application/json',
        };
        this._timeout = (_a = this._options.timeout) !== null && _a !== void 0 ? _a : sdk_core_1.DEFAULT_TIMEOUT;
    }
    postError(submissionUrl, dataJson, attachments) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = this.createFormData(dataJson, attachments);
            return this.post(submissionUrl, formData);
        });
    }
    post(submissionUrl, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const controller = new AbortController();
            const id = setTimeout(() => controller.abort(), this._timeout);
            try {
                const response = yield fetch(submissionUrl, {
                    method: 'POST',
                    body: payload,
                    headers: typeof payload === 'string' ? this.JSON_HEADERS : {},
                    signal: controller.signal,
                });
                clearInterval(id);
                switch (response.status) {
                    case 200: {
                        const result = yield response.json();
                        return sdk_core_1.BacktraceReportSubmissionResult.Ok(result);
                    }
                    case 401:
                    case 403: {
                        return sdk_core_1.BacktraceReportSubmissionResult.OnInvalidToken();
                    }
                    case 429: {
                        return sdk_core_1.BacktraceReportSubmissionResult.OnLimitReached();
                    }
                    default: {
                        return sdk_core_1.BacktraceReportSubmissionResult.OnInternalServerError(response.statusText);
                    }
                }
            }
            catch (err) {
                if (!(err instanceof Error)) {
                    return sdk_core_1.BacktraceReportSubmissionResult.OnUnknownError(err);
                }
                if (err.name === 'AbortError') {
                    return sdk_core_1.BacktraceReportSubmissionResult.OnNetworkingError('Timeout');
                }
                if (sdk_core_1.ConnectionError.isConnectionError(err)) {
                    return sdk_core_1.BacktraceReportSubmissionResult.OnNetworkingError(err.message);
                }
                return sdk_core_1.BacktraceReportSubmissionResult.OnUnknownError(err.message);
            }
        });
    }
    createFormData(json, attachments) {
        const formData = new FormData();
        formData.append(this.UPLOAD_FILE_NAME, json);
        if (!attachments || attachments.length === 0) {
            return formData;
        }
        for (const attachment of attachments) {
            const data = attachment.get();
            if (!data) {
                continue;
            }
            formData.append(`attachment_${attachment.name}`, data);
        }
        return formData;
    }
}
exports.BacktraceBrowserRequestHandler = BacktraceBrowserRequestHandler;


/***/ }),

/***/ 9972:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceBrowserSessionProvider = void 0;
const sdk_core_1 = __webpack_require__(2863);
const TimeHelper_1 = __webpack_require__(4691);
class BacktraceBrowserSessionProvider {
    get lastActive() {
        return this._lastActive;
    }
    constructor() {
        this.SESSION_LAST_ACTIVE = 'backtrace-last-active';
        this.SESSION_GUID = 'backtrace-guid';
        this.newSession = true;
        this.sessionId = sdk_core_1.IdGenerator.uuid();
        this._lastActive = 0;
        if (!window.localStorage) {
            return;
        }
        const lastActive = this.readLastActiveTimestamp();
        if (!lastActive || TimeHelper_1.TimeHelper.now() - lastActive > BacktraceBrowserSessionProvider.PERSISTENCE_INTERVAL) {
            this.updateLastActiveTimestamp();
            localStorage.setItem(this.SESSION_GUID, this.sessionId);
            return;
        }
        this._lastActive = lastActive;
        this.newSession = false;
        this.sessionId = localStorage.getItem(this.SESSION_GUID);
    }
    afterMetricsSubmission() {
        this.updateLastActiveTimestamp();
    }
    shouldSend() {
        // if the document is hidden, we shouldn't send metrics, because the open document
        // is the one who is being used by the user. This condition makes sure two or more web
        // browser tabs of the same app won't report the same metrics or false positive metrics.
        return document.hidden === false;
    }
    readLastActiveTimestamp() {
        const lastActiveStringTimestamp = localStorage.getItem(this.SESSION_LAST_ACTIVE);
        if (!lastActiveStringTimestamp) {
            return undefined;
        }
        const lastActive = parseInt(lastActiveStringTimestamp, 10);
        if (isNaN(lastActive)) {
            return undefined;
        }
        return lastActive;
    }
    updateLastActiveTimestamp() {
        this._lastActive = TimeHelper_1.TimeHelper.now();
        localStorage.setItem(this.SESSION_LAST_ACTIVE, this._lastActive.toString(10));
    }
}
exports.BacktraceBrowserSessionProvider = BacktraceBrowserSessionProvider;
/**
 * Session persistence interval. If no event was send in the persistence interval
 * the session is treaten as an old session.
 */
BacktraceBrowserSessionProvider.PERSISTENCE_INTERVAL = TimeHelper_1.TimeHelper.convertSecondsToMilliseconds(30 * 60);


/***/ }),

/***/ 7062:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceClient = void 0;
const sdk_core_1 = __webpack_require__(2863);
const agentDefinition_1 = __webpack_require__(9176);
const BacktraceBrowserSessionProvider_1 = __webpack_require__(9972);
const BacktraceClientBuilder_1 = __webpack_require__(4457);
class BacktraceClient extends sdk_core_1.BacktraceCoreClient {
    constructor(options, requestHandler, attributeProviders, stackTraceConverter, breadcrumbsEventSubscriber, sessionProvider = new BacktraceBrowserSessionProvider_1.BacktraceBrowserSessionProvider(), sdkOptions = agentDefinition_1.AGENT) {
        super({
            options,
            sdkOptions,
            requestHandler,
            attributeProviders,
            stackTraceConverter,
            sessionProvider,
            debugIdMapProvider: new sdk_core_1.VariableDebugIdMapProvider(window),
            breadcrumbsSetup: {
                subscribers: breadcrumbsEventSubscriber,
            },
        });
        this._disposeController = new AbortController();
        this.captureUnhandledErrors(options.captureUnhandledErrors, options.captureUnhandledPromiseRejections);
    }
    static builder(options) {
        return new BacktraceClientBuilder_1.BacktraceClientBuilder(options);
    }
    /**
     * Initializes the client. If the client already exists, the available instance
     * will be returned and all other options will be ignored.
     * @param options client configuration
     * @param build builder
     * @returns backtrace client
     */
    static initialize(options, build) {
        if (this.instance) {
            return this.instance;
        }
        const builder = this.builder(options);
        build && build(builder);
        this._instance = builder.build();
        return this._instance;
    }
    /**
     * Returns created BacktraceClient instance if the instance exists.
     * Otherwise undefined.
     */
    static get instance() {
        return this._instance;
    }
    /**
     * Disposes the client and all client callbacks
     */
    dispose() {
        this._disposeController.abort();
        super.dispose();
        BacktraceClient._instance = undefined;
    }
    captureUnhandledErrors(captureUnhandledExceptions = true, captureUnhandledRejections = true) {
        if (captureUnhandledExceptions) {
            window.addEventListener('error', (errorEvent) => {
                var _a;
                this.send(new sdk_core_1.BacktraceReport((_a = errorEvent.error) !== null && _a !== void 0 ? _a : errorEvent.message, {
                    'error.type': 'Unhandled exception',
                }));
            }, {
                signal: this._disposeController.signal,
            });
        }
        if (captureUnhandledRejections) {
            window.addEventListener('unhandledrejection', (errorEvent) => {
                this.send(new sdk_core_1.BacktraceReport(errorEvent.reason, {
                    'error.type': 'Unhandled exception',
                }, [], {
                    classifiers: ['UnhandledPromiseRejection'],
                }));
            }, {
                signal: this._disposeController.signal,
            });
        }
    }
}
exports.BacktraceClient = BacktraceClient;


/***/ }),

/***/ 47:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 9176:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AGENT = void 0;
exports.AGENT = {
    langName: 'js',
    langVersion: navigator.userAgent,
    agent: "@backtrace-labs/browser",
    agentVersion: "0.0.5",
};


/***/ }),

/***/ 8523:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ApplicationInformationAttributeProvider = void 0;
class ApplicationInformationAttributeProvider {
    get type() {
        return 'scoped';
    }
    constructor(options) {
        this.APPLICATION_ATTRIBUTE = 'application';
        this.APPLICATION_VERSION_ATTRIBUTE = 'application.version';
        this._application = options.name;
        this._applicationVersion = options.version;
        if (!this._application || !this._applicationVersion) {
            throw new Error('Missing application/application version information!');
        }
    }
    get() {
        return {
            [this.APPLICATION_ATTRIBUTE]: this._application,
            [this.APPLICATION_VERSION_ATTRIBUTE]: this._applicationVersion,
        };
    }
}
exports.ApplicationInformationAttributeProvider = ApplicationInformationAttributeProvider;


/***/ }),

/***/ 3480:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UserAgentAttributeProvider = void 0;
const ua_parser_js_1 = __importDefault(__webpack_require__(6353));
class UserAgentAttributeProvider {
    get type() {
        return 'scoped';
    }
    get() {
        const parser = new ua_parser_js_1.default();
        const information = parser.getResult();
        return {
            'browser.name': information.browser.name,
            'browser.version': information.browser.version,
            'engine.name': information.engine.name,
            'engine.version': information.engine.version,
            'browser.platform': navigator.platform,
            'cpu.arch': information.cpu.architecture,
            'uname.sysname': information.os.name,
            'uname.version': information.os.version,
            'device.model': information.device.model,
            'device.type': information.device.type,
            'device.vendor': information.device.vendor,
            mobile: information.device.type === 'mobile',
            'user.agent.full': information.ua,
        };
    }
}
exports.UserAgentAttributeProvider = UserAgentAttributeProvider;


/***/ }),

/***/ 7782:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UserIdentifierAttributeProvider = void 0;
const sdk_core_1 = __webpack_require__(2863);
class UserIdentifierAttributeProvider {
    constructor() {
        this.USER_IDENTIFIER = 'backtrace-guid';
    }
    get type() {
        return 'scoped';
    }
    get() {
        var _a;
        return {
            guid: (_a = this.generateUuidToLocalStorage()) !== null && _a !== void 0 ? _a : sdk_core_1.IdGenerator.uuid(),
        };
    }
    generateUuidToLocalStorage() {
        if (!window.localStorage) {
            return undefined;
        }
        try {
            let guid = window.localStorage.getItem(this.USER_IDENTIFIER);
            if (!guid) {
                guid = sdk_core_1.IdGenerator.uuid();
                window.localStorage.setItem(this.USER_IDENTIFIER, guid);
            }
            return guid;
        }
        catch (_a) {
            return undefined;
        }
    }
}
exports.UserIdentifierAttributeProvider = UserIdentifierAttributeProvider;


/***/ }),

/***/ 1505:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WebsiteAttributeProvider = void 0;
const TimeHelper_1 = __webpack_require__(4691);
const PAGE_START_TIME = TimeHelper_1.TimeHelper.now();
class WebsiteAttributeProvider {
    get type() {
        return 'scoped';
    }
    get() {
        return {
            application: document.title || 'unknown',
            'process.age': Math.floor((new Date().getTime() - PAGE_START_TIME) / 1000),
            hostname: window.location && window.location.hostname,
            referrer: window.location && window.location.href,
            'location.port': document.location.port,
            'location.protocol': document.location.protocol,
            'location.origin': window.location.origin,
            'location.href': window.location.href || document.URL,
            language: navigator.language,
            'browser.platform': navigator.platform,
            'cookies.enable': navigator.cookieEnabled,
            'document.domain': document.domain,
            'document.baseURI': document.baseURI,
            'document.title': document.title,
            'document.referrer': document.referrer,
            'localstorage.enable': !!window.localStorage,
        };
    }
}
exports.WebsiteAttributeProvider = WebsiteAttributeProvider;


/***/ }),

/***/ 2794:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WindowAttributeProvider = void 0;
class WindowAttributeProvider {
    get type() {
        return 'dynamic';
    }
    get() {
        return {
            'window.innerHeight': window.innerHeight,
            'window.innerWidth': window.innerWidth,
            'window.outerHeight': window.outerHeight,
            'window.outerWidth': window.outerWidth,
            'window.pageXOffset': window.pageXOffset,
            'window.pageYOffset': window.pageYOffset,
            'window.screenX': window.screenX,
            'window.screenY': window.screenY,
            'window.screenLeft': window.screenLeft,
            'window.screenTop': window.screenTop,
        };
    }
}
exports.WindowAttributeProvider = WindowAttributeProvider;


/***/ }),

/***/ 7429:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DocumentEventSubscriber = void 0;
const sdk_core_1 = __webpack_require__(2863);
class DocumentEventSubscriber {
    constructor() {
        this._controller = new AbortController();
    }
    start(breadcrumbsManager) {
        const signal = this._controller.signal;
        document.addEventListener('click', (mouseEvent) => {
            const target = mouseEvent.target;
            if (!target) {
                return;
            }
            breadcrumbsManager.addBreadcrumb(`Clicked ${target.id} ${target.tagName}`, sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.User, {
                id: target.id,
                class: target.className,
                name: target.tagName,
                text: target === null || target === void 0 ? void 0 : target.text,
            });
        }, {
            signal,
        });
        document.addEventListener('dblclick', (mouseEvent) => {
            const target = mouseEvent.target;
            if (!target) {
                return;
            }
            breadcrumbsManager.addBreadcrumb(`Double clicked ${target.id} ${target.tagName}`, sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.User, {
                id: target.id,
                class: target.className,
                name: target.tagName,
                text: target === null || target === void 0 ? void 0 : target.text,
            });
        }, {
            signal,
        });
        document.addEventListener('drag', (dragEvent) => {
            const target = dragEvent.target;
            if (!target) {
                return;
            }
            breadcrumbsManager.addBreadcrumb(`An element ${target.id} ${target.tagName} is being dragged`, sdk_core_1.BreadcrumbLogLevel.Debug, sdk_core_1.BreadcrumbType.User, {
                id: target.id,
                class: target.className,
                name: target.tagName,
            });
        }, {
            signal,
        });
        document.addEventListener('drop', (dragEvent) => {
            const target = dragEvent.target;
            if (!target) {
                return;
            }
            breadcrumbsManager.addBreadcrumb(`A dragged element is dropped on the target	${target.id} ${target.tagName}`, sdk_core_1.BreadcrumbLogLevel.Debug, sdk_core_1.BreadcrumbType.User, {
                id: target.id,
                class: target.className,
                name: target.tagName,
            });
        }, {
            signal,
        });
        window.addEventListener('load', () => {
            breadcrumbsManager.addBreadcrumb(`The page has loaded`, sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.System);
        });
        window.addEventListener('unload', () => {
            breadcrumbsManager.addBreadcrumb(`The page started unloading`, sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.System);
        });
        window.addEventListener('pagehide', () => {
            breadcrumbsManager.addBreadcrumb('User navigates away from a webpage', sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.User);
        });
        window.addEventListener('pageshow', () => {
            breadcrumbsManager.addBreadcrumb('User navigates to a webpage', sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.User);
        });
        window.addEventListener('online', () => {
            breadcrumbsManager.addBreadcrumb(`The browser starts working online`, sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.System);
        }, {
            signal,
        });
        window.addEventListener('offline', () => {
            breadcrumbsManager.addBreadcrumb(`The browser starts working offline	`, sdk_core_1.BreadcrumbLogLevel.Warning, sdk_core_1.BreadcrumbType.System);
        }, {
            signal,
        });
    }
    dispose() {
        this._controller.abort();
    }
}
exports.DocumentEventSubscriber = DocumentEventSubscriber;


/***/ }),

/***/ 6762:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HistoryEventSubscriber = void 0;
const sdk_core_1 = __webpack_require__(2863);
class HistoryEventSubscriber {
    constructor() {
        this._abortController = new AbortController();
    }
    start(breadcrumbsManager) {
        if ((breadcrumbsManager.breadcrumbsType & sdk_core_1.BreadcrumbType.Navigation) !== sdk_core_1.BreadcrumbType.Navigation) {
            return;
        }
        window.addEventListener('popstate', (event) => {
            breadcrumbsManager.addBreadcrumb(`Navigating back to ${document.location}`, sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.Navigation, {
                location: document.location.toString(),
                state: event.state,
            });
        }, {
            signal: this._abortController.signal,
        });
        const originalHistoryPushStateMethod = history.pushState;
        history.pushState = (...args) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [data, _, url] = args;
            originalHistoryPushStateMethod.apply(history, args);
            breadcrumbsManager.addBreadcrumb(`Navigating to ${document.location}`, sdk_core_1.BreadcrumbLogLevel.Info, sdk_core_1.BreadcrumbType.Navigation, {
                url: url === null || url === void 0 ? void 0 : url.toString(),
                data,
                location: document.location.toString(),
            });
        };
        this._originalHistoryPushStateMethod = originalHistoryPushStateMethod;
    }
    dispose() {
        this._abortController.abort();
        if (this._originalHistoryPushStateMethod) {
            history.pushState = this._originalHistoryPushStateMethod;
        }
    }
}
exports.HistoryEventSubscriber = HistoryEventSubscriber;


/***/ }),

/***/ 4694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WebRequestEventSubscriber = void 0;
const sdk_core_1 = __webpack_require__(2863);
class WebRequestEventSubscriber {
    start(breadcrumbsManager) {
        if ((breadcrumbsManager.breadcrumbsType & sdk_core_1.BreadcrumbType.Http) !== sdk_core_1.BreadcrumbType.Http) {
            return;
        }
        const xmlHttpRequestOriginalOpenMethod = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url, async, username, password) {
            const readyStateChangeCallback = this.onreadystatechange;
            this.onreadystatechange = (event) => {
                if (this.readyState === XMLHttpRequest.DONE) {
                    breadcrumbsManager.addBreadcrumb(`Sent an HTTP ${method} request to ${url}. Response status code: ${this.status}`, sdk_core_1.BreadcrumbLogLevel.Debug, sdk_core_1.BreadcrumbType.Http, {
                        method,
                        url: url.toString(),
                        statusCode: this.status,
                    });
                }
                readyStateChangeCallback === null || readyStateChangeCallback === void 0 ? void 0 : readyStateChangeCallback.apply(this, [event]);
            };
            xmlHttpRequestOriginalOpenMethod.call(this, method, url, async || true, username, password);
        };
        this._xmlHttpRequestOriginalOpenMethod = xmlHttpRequestOriginalOpenMethod;
        const fetchOriginalMethod = window.fetch;
        window.fetch = function (resource, config) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const method = (_a = config === null || config === void 0 ? void 0 : config.method) !== null && _a !== void 0 ? _a : 'GET';
                const attributes = {
                    url: resource.toString(),
                    method: method,
                    referrer: config === null || config === void 0 ? void 0 : config.referrer,
                };
                try {
                    const result = yield fetchOriginalMethod(resource, config);
                    breadcrumbsManager.addBreadcrumb(`Sent an HTTP ${method} request to ${resource}. Response status code: ${result.status}`, sdk_core_1.BreadcrumbLogLevel.Debug, sdk_core_1.BreadcrumbType.Http, Object.assign(Object.assign({}, attributes), { statusCode: result.status }));
                    return result;
                }
                catch (e) {
                    breadcrumbsManager.addBreadcrumb(`HTTP ${method} failure on request to ${resource}. Reason: ${e instanceof Error ? e.message : (_b = e === null || e === void 0 ? void 0 : e.toString()) !== null && _b !== void 0 ? _b : 'unknown'}`, sdk_core_1.BreadcrumbLogLevel.Warning, sdk_core_1.BreadcrumbType.Http, attributes);
                    throw e;
                }
            });
        };
        this._fetchOriginalMethod = fetchOriginalMethod;
    }
    dispose() {
        if (this._fetchOriginalMethod) {
            window.fetch = this._fetchOriginalMethod;
        }
        if (this._xmlHttpRequestOriginalOpenMethod) {
            XMLHttpRequest.prototype.open = this._xmlHttpRequestOriginalOpenMethod;
        }
    }
}
exports.WebRequestEventSubscriber = WebRequestEventSubscriber;


/***/ }),

/***/ 4457:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceClientBuilder = void 0;
const sdk_core_1 = __webpack_require__(2863);
const V8StackTraceConverter_1 = __webpack_require__(3065);
const BacktraceBrowserRequestHandler_1 = __webpack_require__(1345);
const BacktraceBrowserSessionProvider_1 = __webpack_require__(9972);
const BacktraceClient_1 = __webpack_require__(7062);
const ApplicationInformationAttributeProvider_1 = __webpack_require__(8523);
const UserAgentAttributeProvider_1 = __webpack_require__(3480);
const UserIdentifierAttributeProvider_1 = __webpack_require__(7782);
const WebsiteAttributeProvider_1 = __webpack_require__(1505);
const WindowAttributeProvider_1 = __webpack_require__(2794);
const DocumentEventSubscriber_1 = __webpack_require__(7429);
const HistoryEventSubscriber_1 = __webpack_require__(6762);
const WebRequestEventSubscriber_1 = __webpack_require__(4694);
const JavaScriptCoreStackTraceConverter_1 = __webpack_require__(5562);
const SpiderMonkeyStackTraceConverter_1 = __webpack_require__(471);
const engineDetector_1 = __webpack_require__(1342);
class BacktraceClientBuilder extends sdk_core_1.BacktraceCoreClientBuilder {
    constructor(options, attributeProviders = [
        new UserAgentAttributeProvider_1.UserAgentAttributeProvider(),
        new WebsiteAttributeProvider_1.WebsiteAttributeProvider(),
        new WindowAttributeProvider_1.WindowAttributeProvider(),
        new UserIdentifierAttributeProvider_1.UserIdentifierAttributeProvider(),
        new ApplicationInformationAttributeProvider_1.ApplicationInformationAttributeProvider(options),
    ], breadcrumbsSubscribers = [
        new WebRequestEventSubscriber_1.WebRequestEventSubscriber(),
        new DocumentEventSubscriber_1.DocumentEventSubscriber(),
        new HistoryEventSubscriber_1.HistoryEventSubscriber(),
    ], sessionProvider = new BacktraceBrowserSessionProvider_1.BacktraceBrowserSessionProvider()) {
        super(new BacktraceBrowserRequestHandler_1.BacktraceBrowserRequestHandler(options), attributeProviders, breadcrumbsSubscribers, sessionProvider);
        this.options = options;
    }
    build() {
        var _a;
        const instance = new BacktraceClient_1.BacktraceClient(this.options, this.handler, this.attributeProviders, (_a = this.stackTraceConverter) !== null && _a !== void 0 ? _a : this.generateStackTraceConverter(), this.breadcrumbsSubscribers, this.sessionProvider);
        instance.initialize();
        return instance;
    }
    generateStackTraceConverter() {
        switch ((0, engineDetector_1.getEngine)()) {
            case 'JavaScriptCore': {
                return new JavaScriptCoreStackTraceConverter_1.JavaScriptCoreStackTraceConverter();
            }
            case 'SpiderMonkey': {
                return new SpiderMonkeyStackTraceConverter_1.SpiderMonkeyStackTraceConverter();
            }
            default: {
                return new V8StackTraceConverter_1.V8StackTraceConverter();
            }
        }
    }
}
exports.BacktraceClientBuilder = BacktraceClientBuilder;


/***/ }),

/***/ 5562:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.JavaScriptCoreStackTraceConverter = void 0;
const sdk_core_1 = __webpack_require__(2863);
class JavaScriptCoreStackTraceConverter {
    get engine() {
        return 'JavaScriptCore';
    }
    convert(stackTrace) {
        const result = [];
        const stackFrames = stackTrace.split('\n');
        for (const stackFrame of stackFrames) {
            const normalizedStackFrame = stackFrame.trim();
            const frame = this.parseFrame(normalizedStackFrame);
            result.push(frame);
        }
        return result;
    }
    parseFrame(stackFrame) {
        const functionSeparatorIndex = this.generateSeparatorIndex(stackFrame);
        let functionName = functionSeparatorIndex === -1 ? sdk_core_1.ANONYMOUS_FUNCTION : stackFrame.substring(0, functionSeparatorIndex);
        if (!functionName) {
            functionName = sdk_core_1.ANONYMOUS_FUNCTION;
        }
        const sourceCodeInformation = stackFrame.substring(functionSeparatorIndex + 1);
        const sourceCodeParts = sourceCodeInformation.split(':');
        if (sourceCodeParts.length === 1) {
            return {
                funcName: functionName,
                library: sourceCodeInformation ? sourceCodeInformation : sdk_core_1.UNKNOWN_FRAME,
            };
        }
        const column = parseInt(sourceCodeParts[sourceCodeParts.length - 1]);
        const line = parseInt(sourceCodeParts[sourceCodeParts.length - 2]);
        const library = sourceCodeParts.slice(0, sourceCodeParts.length - 2).join(':');
        return {
            funcName: functionName,
            column: isNaN(column) ? undefined : column,
            line: isNaN(line) ? undefined : line,
            library: library,
        };
    }
    generateSeparatorIndex(stackFrame) {
        const functionSeparator = '@';
        const functionSeparatorIndex = stackFrame.indexOf(functionSeparator);
        if (functionSeparatorIndex === -1) {
            return functionSeparatorIndex;
        }
        const isMoreSeparators = stackFrame.lastIndexOf(functionSeparator) !== functionSeparatorIndex;
        if (!isMoreSeparators) {
            return functionSeparatorIndex;
        }
        const possibleSeparators = ['@http', '@file'];
        for (const possibleSeparator of possibleSeparators) {
            const possibleSeparatorIndex = stackFrame.indexOf(possibleSeparator);
            if (possibleSeparatorIndex !== -1) {
                return possibleSeparatorIndex;
            }
        }
        // we can't determinate the separator
        return functionSeparatorIndex;
    }
}
exports.JavaScriptCoreStackTraceConverter = JavaScriptCoreStackTraceConverter;


/***/ }),

/***/ 471:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SpiderMonkeyStackTraceConverter = void 0;
const sdk_core_1 = __webpack_require__(2863);
class SpiderMonkeyStackTraceConverter {
    constructor() {
        this.ANONYMOUS_FUNCTIONS = ['()', '(null)', ''];
    }
    get engine() {
        return 'SpiderMonkey';
    }
    convert(stackTrace) {
        const result = [];
        const stackFrames = stackTrace.split('\n');
        for (const stackFrame of stackFrames) {
            const normalizedStackFrame = stackFrame.trim();
            if (!normalizedStackFrame) {
                continue;
            }
            const frame = this.parseFrame(normalizedStackFrame);
            if (this.ANONYMOUS_FUNCTIONS.includes(frame.funcName)) {
                frame.funcName = sdk_core_1.ANONYMOUS_FUNCTION;
            }
            result.push(frame);
        }
        return result;
    }
    parseFrame(stackFrame) {
        const functionSeparatorIndex = this.generateSeparatorIndex(stackFrame);
        //invalid frame
        if (functionSeparatorIndex === -1) {
            return {
                funcName: stackFrame,
                library: sdk_core_1.UNKNOWN_FRAME,
            };
        }
        let functionName = stackFrame.substring(0, functionSeparatorIndex);
        if (!functionName) {
            functionName = sdk_core_1.ANONYMOUS_FUNCTION;
        }
        let sourceCodeInformation = stackFrame.substring(functionSeparatorIndex + 1);
        if (sourceCodeInformation.indexOf('eval') !== -1) {
            sourceCodeInformation = this.cleanUpEvalInformation(sourceCodeInformation);
        }
        const sourceCodeParts = sourceCodeInformation.split(':');
        // check if the column information is available - if is not, we should use the legacy parser
        const sourceCodeOrRowNumber = sourceCodeParts[sourceCodeParts.length - 2];
        const possibleRowNumber = parseInt(sourceCodeOrRowNumber);
        return isNaN(possibleRowNumber)
            ? this.generateLegacyFirefoxFrame(functionName, sourceCodeParts)
            : this.generateFirefoxFrame(functionName, sourceCodeParts);
    }
    generateSeparatorIndex(stackFrame) {
        const functionSeparator = '@';
        const functionSeparatorIndex = stackFrame.indexOf(functionSeparator);
        if (functionSeparatorIndex === -1) {
            return functionSeparatorIndex;
        }
        const isMoreSeparators = stackFrame.lastIndexOf(functionSeparator) !== functionSeparatorIndex;
        if (!isMoreSeparators) {
            return functionSeparatorIndex;
        }
        const possibleSeparators = ['@http', '@file'];
        for (const possibleSeparator of possibleSeparators) {
            const possibleSeparatorIndex = stackFrame.indexOf(possibleSeparator);
            if (possibleSeparatorIndex !== -1) {
                return possibleSeparatorIndex;
            }
        }
        // we can't determinate the separator
        return functionSeparatorIndex;
    }
    generateLegacyFirefoxFrame(functionName, sourceCodeParts) {
        const lineNumberStart = sourceCodeParts.length - 1;
        const lineNumber = parseInt(sourceCodeParts[lineNumberStart]);
        const library = sourceCodeParts.slice(0, lineNumberStart).join(':');
        return {
            library: library,
            funcName: functionName,
            line: isNaN(lineNumber) ? undefined : lineNumber,
        };
    }
    generateFirefoxFrame(functionName, sourceCodeParts) {
        const lineNumberStart = sourceCodeParts.length - 2;
        const lineNumber = parseInt(sourceCodeParts[lineNumberStart]);
        const columnName = parseInt(sourceCodeParts[lineNumberStart + 1]);
        const library = sourceCodeParts.slice(0, lineNumberStart).join(':');
        return {
            library: library,
            funcName: functionName,
            column: columnName,
            line: lineNumber,
        };
    }
    cleanUpEvalInformation(sourceCodeInformation) {
        const evalSeparator = ' > eval';
        const evalIndex = sourceCodeInformation.indexOf(evalSeparator);
        if (evalIndex === -1) {
            return sourceCodeInformation;
        }
        const lineSeparator = ' line ';
        const lineSeparatorIndex = sourceCodeInformation.indexOf(lineSeparator);
        if (lineSeparatorIndex === -1) {
            return sourceCodeInformation.replace(evalSeparator, '');
        }
        const textToRemove = sourceCodeInformation.substring(lineSeparatorIndex, evalIndex + evalSeparator.length);
        return sourceCodeInformation.replace(textToRemove, '');
    }
}
exports.SpiderMonkeyStackTraceConverter = SpiderMonkeyStackTraceConverter;


/***/ }),

/***/ 1342:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getEngine = void 0;
function getEngine() {
    if (!navigator.userAgent) {
        return 'v8';
    }
    const normalizedUserAgent = navigator.userAgent.toLowerCase();
    if (normalizedUserAgent.includes('firefox')) {
        return 'SpiderMonkey';
    }
    if (normalizedUserAgent.includes('safari') && !normalizedUserAgent.includes('chrome')) {
        return 'JavaScriptCore';
    }
    return 'v8';
}
exports.getEngine = getEngine;


/***/ }),

/***/ 1920:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V8StackTraceConverter = exports.SingleSessionProvider = exports.BreadcrumbType = exports.BreadcrumbsManager = exports.BreadcrumbLogLevel = exports.BacktraceUint8ArrayAttachment = exports.BacktraceStringAttachment = exports.BacktraceReport = void 0;
var sdk_core_1 = __webpack_require__(2863);
Object.defineProperty(exports, "BacktraceReport", ({ enumerable: true, get: function () { return sdk_core_1.BacktraceReport; } }));
Object.defineProperty(exports, "BacktraceStringAttachment", ({ enumerable: true, get: function () { return sdk_core_1.BacktraceStringAttachment; } }));
Object.defineProperty(exports, "BacktraceUint8ArrayAttachment", ({ enumerable: true, get: function () { return sdk_core_1.BacktraceUint8ArrayAttachment; } }));
Object.defineProperty(exports, "BreadcrumbLogLevel", ({ enumerable: true, get: function () { return sdk_core_1.BreadcrumbLogLevel; } }));
Object.defineProperty(exports, "BreadcrumbsManager", ({ enumerable: true, get: function () { return sdk_core_1.BreadcrumbsManager; } }));
Object.defineProperty(exports, "BreadcrumbType", ({ enumerable: true, get: function () { return sdk_core_1.BreadcrumbType; } }));
Object.defineProperty(exports, "SingleSessionProvider", ({ enumerable: true, get: function () { return sdk_core_1.SingleSessionProvider; } }));
Object.defineProperty(exports, "V8StackTraceConverter", ({ enumerable: true, get: function () { return sdk_core_1.V8StackTraceConverter; } }));
__exportStar(__webpack_require__(9176), exports);
__exportStar(__webpack_require__(1345), exports);
__exportStar(__webpack_require__(7062), exports);
__exportStar(__webpack_require__(47), exports);
__exportStar(__webpack_require__(4457), exports);
__exportStar(__webpack_require__(628), exports);


/***/ }),

/***/ 628:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createBacktraceReduxMiddleware = void 0;
const sdk_core_1 = __webpack_require__(2863);
/**
 *
 * @param client BacktraceClient used to send breadcrumbs
 * @param interceptAction A function that can be used to skip an action or filter out information from a dispatched action, such as PII, that shouldn't be sent to Backtrace. Return undefined to skip an action, otherwise whatever (potentially modified) action returned will be sent to Backtrace.
 */
const createBacktraceReduxMiddleware = (client, interceptAction = (action) => action) => {
    if (!client) {
        throw new Error('Must pass a BacktraceClient to the BacktraceReduxMiddleware.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const middleware = (store) => (next) => (action) => {
        var _a, _b, _c, _d;
        try {
            const response = next(action);
            const interceptedAction = interceptAction(action);
            // If the user returns undefined for an action, we skip the breadcrumb
            if (interceptedAction) {
                (_a = client.breadcrumbs) === null || _a === void 0 ? void 0 : _a.info(`REDUX Action: ${JSON.stringify(interceptedAction, (0, sdk_core_1.jsonEscaper)())}`);
            }
            return response;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : (_b = err === null || err === void 0 ? void 0 : err.toString()) !== null && _b !== void 0 ? _b : 'unknown';
            (_c = client.breadcrumbs) === null || _c === void 0 ? void 0 : _c.warn(`A problem occurred during action ${(_d = action === null || action === void 0 ? void 0 : action.type) !== null && _d !== void 0 ? _d : 'unknown'}. Reason: ${message}`);
            throw err;
        }
    };
    return middleware;
};
exports.createBacktraceReduxMiddleware = createBacktraceReduxMiddleware;


/***/ }),

/***/ 6353:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.35',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 350;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        VIERA   = 'Viera',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish/Huawei Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2| pro)?)/i                                                // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /ios;fbsv\/([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 4330:
/***/ ((module) => {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 82:
/***/ ((module) => {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 3335:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(82);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(4330);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ 7605:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceCoreClient = void 0;
const _1 = __webpack_require__(2863);
const Events_1 = __webpack_require__(3286);
const BacktraceReportSubmission_1 = __webpack_require__(4543);
const BacktraceReport_1 = __webpack_require__(492);
const AttributeManager_1 = __webpack_require__(8240);
const ClientAttributeProvider_1 = __webpack_require__(6743);
const UserAttributeProvider_1 = __webpack_require__(8094);
const BreadcrumbsManager_1 = __webpack_require__(6576);
const V8StackTraceConverter_1 = __webpack_require__(3065);
const BacktraceDataBuilder_1 = __webpack_require__(4350);
const BacktraceDatabase_1 = __webpack_require__(2674);
const BacktraceDatabaseFileStorageProvider_1 = __webpack_require__(96);
const BacktraceMetrics_1 = __webpack_require__(9923);
const MetricsBuilder_1 = __webpack_require__(5666);
const SingleSessionProvider_1 = __webpack_require__(1612);
const RateLimitWatcher_1 = __webpack_require__(1533);
class BacktraceCoreClient {
    /**
     * Determines if the client is enabled.
     */
    get enabled() {
        return this._enabled;
    }
    /**
     * Current session id
     */
    get sessionId() {
        return this._sessionProvider.sessionId;
    }
    /**
     * Backtrace SDK name
     */
    get agent() {
        return this._sdkOptions.agent;
    }
    /**
     * Backtrace SDK version
     */
    get agentVersion() {
        return this._sdkOptions.agentVersion;
    }
    /**
     * Available cached client attributes
     */
    get attributes() {
        return this.attributeManager.get().attributes;
    }
    /**
     * Available cached client annotatations
     */
    get annotations() {
        return this.attributeManager.get().annotations;
    }
    get metrics() {
        return this._modules.get(BacktraceMetrics_1.BacktraceMetrics);
    }
    get breadcrumbs() {
        return this._modules.get(BreadcrumbsManager_1.BreadcrumbsManager);
    }
    get database() {
        return this._modules.get(BacktraceDatabase_1.BacktraceDatabase);
    }
    /**
     * Client cached attachments
     */
    get attachments() {
        // always return a copy of attachments
        return [...this._attachments];
    }
    /**
     * Modules used by the client
     */
    get modules() {
        return this._modules;
    }
    get sessionFiles() {
        return this._modules.get(_1.SessionFiles);
    }
    constructor(_setup) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this._setup = _setup;
        this._modules = new Map();
        this._enabled = false;
        this.reportEvents = new Events_1.Events();
        this.options = _setup.options;
        this.fileSystem = _setup.fileSystem;
        this._sdkOptions = _setup.sdkOptions;
        this._attachments = (_a = this.options.attachments) !== null && _a !== void 0 ? _a : [];
        this._sessionProvider = (_b = this._setup.sessionProvider) !== null && _b !== void 0 ? _b : new SingleSessionProvider_1.SingleSessionProvider();
        this._reportSubmission = new BacktraceReportSubmission_1.BacktraceReportSubmission(this.options, this._setup.requestHandler);
        this._rateLimitWatcher = new RateLimitWatcher_1.RateLimitWatcher(this.options.rateLimit);
        const attributeProviders = [
            new ClientAttributeProvider_1.ClientAttributeProvider(this.agent, this.agentVersion, this._sessionProvider.sessionId),
        ];
        if (this._setup.attributeProviders) {
            attributeProviders.push(...this._setup.attributeProviders);
        }
        if (this._setup.options.userAttributes) {
            attributeProviders.push(new UserAttributeProvider_1.UserAttributeProvider(this._setup.options.userAttributes));
        }
        this.attributeManager = new AttributeManager_1.AttributeManager(attributeProviders);
        const stackTraceConverter = (_c = this._setup.stackTraceConverter) !== null && _c !== void 0 ? _c : new V8StackTraceConverter_1.V8StackTraceConverter();
        this._dataBuilder = new BacktraceDataBuilder_1.BacktraceDataBuilder(this._sdkOptions, stackTraceConverter, this.attributeManager, new _1.DebugIdProvider(stackTraceConverter, this._setup.debugIdMapProvider));
        if (((_e = (_d = this.options) === null || _d === void 0 ? void 0 : _d.database) === null || _e === void 0 ? void 0 : _e.enable) === true && this._setup.fileSystem) {
            const provider = BacktraceDatabaseFileStorageProvider_1.BacktraceDatabaseFileStorageProvider.createIfValid(this._setup.fileSystem, this.options.database);
            if (this.fileSystem) {
                const sessionFiles = new _1.SessionFiles(this.fileSystem, this.options.database.path, this.sessionId, (_f = this.options.database.maximumOldSessions) !== null && _f !== void 0 ? _f : 1);
                this._modules.set(_1.SessionFiles, sessionFiles);
            }
            if (provider) {
                const database = new BacktraceDatabase_1.BacktraceDatabase(this.options.database, provider, this._reportSubmission, this.sessionFiles);
                this._modules.set(BacktraceDatabase_1.BacktraceDatabase, database);
            }
        }
        const metrics = new MetricsBuilder_1.MetricsBuilder(this.options, this._sessionProvider, this.attributeManager, this._setup.requestHandler).build();
        if (metrics) {
            this._modules.set(BacktraceMetrics_1.BacktraceMetrics, metrics);
        }
        if (((_g = this.options.breadcrumbs) === null || _g === void 0 ? void 0 : _g.enable) !== false) {
            const breadcrumbsManager = new BreadcrumbsManager_1.BreadcrumbsManager((_h = this.options) === null || _h === void 0 ? void 0 : _h.breadcrumbs, this._setup.breadcrumbsSetup);
            this._modules.set(BreadcrumbsManager_1.BreadcrumbsManager, breadcrumbsManager);
        }
        this._enabled = true;
    }
    initialize() {
        var _a, _b, _c;
        if (this.fileSystem && ((_a = this.options.database) === null || _a === void 0 ? void 0 : _a.createDatabaseDirectory)) {
            if (!this.options.database.path) {
                throw new Error('Missing mandatory path to the database. Please define the database.path option in the configuration.');
            }
            this.fileSystem.createDirSync((_b = this.options.database) === null || _b === void 0 ? void 0 : _b.path);
        }
        for (const module of this._modules.values()) {
            if (module.bind) {
                module.bind(this.getModuleBindData());
            }
            if (module.initialize) {
                module.initialize();
            }
        }
        (_c = this.sessionFiles) === null || _c === void 0 ? void 0 : _c.clearPreviousSessions();
    }
    addAttribute(attributes) {
        this.attributeManager.add(attributes);
    }
    /**
     * Add attachment to the client
     * @param attachment attachment
     */
    addAttachment(attachment) {
        this._attachments.push(attachment);
    }
    // This function CANNOT be an async function due to possible async state machine stack frame inclusion, which breaks the skip stacks
    send(data, reportAttributes = {}, reportAttachments = []) {
        if (!this._enabled) {
            return Promise.resolve();
        }
        if (this._rateLimitWatcher.skipReport()) {
            return Promise.resolve();
        }
        const report = this.isReport(data)
            ? data
            : new BacktraceReport_1.BacktraceReport(data, reportAttributes, [], {
                skipFrames: this.skipFrameOnMessage(data),
            });
        this.reportEvents.emit('before-skip', report);
        if (this.options.skipReport && this.options.skipReport(report)) {
            return Promise.resolve();
        }
        const backtraceData = this.generateSubmissionData(report);
        if (!backtraceData) {
            return Promise.resolve();
        }
        const submissionAttachments = this.generateSubmissionAttachments(report, reportAttachments);
        this.reportEvents.emit('before-send', report, backtraceData, submissionAttachments);
        return this._reportSubmission.send(backtraceData, submissionAttachments).then((submissionResult) => {
            this.reportEvents.emit('after-send', report, backtraceData, submissionAttachments, submissionResult);
        });
    }
    /**
     * Disposes the client and all client callbacks
     */
    dispose() {
        this._enabled = false;
        for (const module of this._modules.values()) {
            if (module.dispose) {
                module.dispose();
            }
        }
    }
    addModule(type, module) {
        this._modules.set(type, module);
    }
    generateSubmissionData(report) {
        const backtraceData = this._dataBuilder.build(report);
        if (!this.options.beforeSend) {
            return backtraceData;
        }
        return this.options.beforeSend(backtraceData);
    }
    generateSubmissionAttachments(report, reportAttachments) {
        var _a;
        return [...this._attachments, ...((_a = report.attachments) !== null && _a !== void 0 ? _a : []), ...(reportAttachments !== null && reportAttachments !== void 0 ? reportAttachments : [])];
    }
    skipFrameOnMessage(data) {
        return typeof data === 'string' ? 1 : 0;
    }
    isReport(data) {
        return data instanceof BacktraceReport_1.BacktraceReport;
    }
    getModuleBindData() {
        return {
            client: this,
            reportEvents: this.reportEvents,
            attributeManager: this.attributeManager,
            sessionFiles: this.sessionFiles,
        };
    }
}
exports.BacktraceCoreClient = BacktraceCoreClient;
//# sourceMappingURL=BacktraceCoreClient.js.map

/***/ }),

/***/ 5776:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceCoreClientBuilder = void 0;
class BacktraceCoreClientBuilder {
    constructor(handler, attributeProviders = [], breadcrumbsSubscribers = [], sessionProvider) {
        this.handler = handler;
        this.attributeProviders = attributeProviders;
        this.breadcrumbsSubscribers = breadcrumbsSubscribers;
        this.sessionProvider = sessionProvider;
    }
    addAttributeProvider(provider) {
        this.attributeProviders.push(provider);
        return this;
    }
    useBreadcrumbSubscriber(breadcrumbSubscriber) {
        this.breadcrumbsSubscribers.push(breadcrumbSubscriber);
        return this;
    }
    useSessionProvider(sessionProvider) {
        this.sessionProvider = sessionProvider;
        return this;
    }
    useRequestHandler(handler) {
        this.handler = handler;
        return this;
    }
    useStackTraceConverter(stackTraceConverter) {
        this.stackTraceConverter = stackTraceConverter;
        return this;
    }
    useFileSystem(fileSystem) {
        this.fileSystem = fileSystem;
        return this;
    }
}
exports.BacktraceCoreClientBuilder = BacktraceCoreClientBuilder;
//# sourceMappingURL=BacktraceCoreClientBuilder.js.map

/***/ }),

/***/ 1403:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=SdkOptions.js.map

/***/ }),

/***/ 4815:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Delay = void 0;
class Delay {
    /**
     * Promise set timeout wrapper.
     * @param timeout timeout in ms
     * @param signal abort signal
     */
    static wait(timeout, signal) {
        return new Promise((resolve, reject) => {
            function abortCallback() {
                clearTimeout(intervalId);
                reject(new Error('Operation cancelled.'));
            }
            const intervalId = setTimeout(() => {
                signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortCallback);
                resolve();
            }, timeout);
            signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abortCallback);
        });
    }
}
exports.Delay = Delay;
//# sourceMappingURL=DelayHelper.js.map

/***/ }),

/***/ 3286:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Events = void 0;
class Events {
    constructor() {
        this._callbacks = {};
    }
    on(event, callback) {
        this.addCallback(event, { callback });
        return this;
    }
    once(event, callback) {
        this.addCallback(event, { callback, once: true });
        return this;
    }
    off(event, callback) {
        this.removeCallback(event, callback);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this._callbacks[event];
        if (!callbacks || !callbacks.length) {
            return false;
        }
        for (const { callback, once } of [...callbacks]) {
            try {
                callback(...args);
            }
            catch (_a) {
                // Do nothing
            }
            if (once) {
                this.removeCallback(event, callback);
            }
        }
        return true;
    }
    addCallback(event, callback) {
        const list = this._callbacks[event];
        if (list) {
            list.push(callback);
        }
        else {
            this._callbacks[event] = [callback];
        }
    }
    removeCallback(event, callback) {
        const list = this._callbacks[event];
        if (!list) {
            return;
        }
        const index = list.findIndex((el) => el.callback === callback);
        if (index === -1) {
            return;
        }
        list.splice(index, 1);
        if (!list.length) {
            delete this._callbacks[event];
        }
    }
}
exports.Events = Events;
//# sourceMappingURL=Events.js.map

/***/ }),

/***/ 3591:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IdGenerator = void 0;
class IdGenerator {
    static uuid() {
        const bytes = [...new Array(16)].map(() => Math.floor(Math.random() * 256));
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        return (bytes
            .slice(0, 4)
            .map((n) => n.toString(16).padStart(2, '0'))
            .join('') +
            '-' +
            bytes
                .slice(4, 6)
                .map((n) => n.toString(16).padStart(2, '0'))
                .join('') +
            '-' +
            bytes
                .slice(6, 8)
                .map((n) => n.toString(16).padStart(2, '0'))
                .join('') +
            '-' +
            bytes
                .slice(8, 10)
                .map((n) => n.toString(16).padStart(2, '0'))
                .join('') +
            '-' +
            bytes
                .slice(10, 16)
                .map((n) => n.toString(16).padStart(2, '0'))
                .join(''));
    }
}
exports.IdGenerator = IdGenerator;
//# sourceMappingURL=IdGenerator.js.map

/***/ }),

/***/ 4691:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimeHelper = void 0;
class TimeHelper {
    static now() {
        return Date.now();
    }
    static toTimestampInSec(timestampMs) {
        return Math.floor(timestampMs / 1000);
    }
    static convertSecondsToMilliseconds(timeInSec) {
        return timeInSec * 1000;
    }
}
exports.TimeHelper = TimeHelper;
//# sourceMappingURL=TimeHelper.js.map

/***/ }),

/***/ 5661:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.jsonEscaper = void 0;
function jsonEscaper() {
    const ancestors = [];
    const keys = [];
    // in TypeScript add "this: any" param to avoid compliation errors - as follows
    //    return function (this: any, field: any, value: any) {
    return function (key, value) {
        if (!key) {
            return value;
        }
        if (value === null) {
            return value;
        }
        const valueType = typeof value;
        if (valueType === 'bigint') {
            return value.toString();
        }
        if (valueType !== 'object') {
            return value;
        }
        // `this` is the object that value is contained in,
        // i.e., its direct parent.
        while (ancestors.length > 0 && ancestors[ancestors.length - 1] !== this) {
            ancestors.pop();
            keys.pop();
        }
        if (ancestors.includes(value)) {
            return `[Circular].${keys.join('.')}.${key}`;
        }
        keys.push(key);
        ancestors.push(value);
        return value;
    };
}
exports.jsonEscaper = jsonEscaper;
//# sourceMappingURL=jsonEscaper.js.map

/***/ }),

/***/ 439:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.textFormatter = void 0;
const jsonEscaper_1 = __webpack_require__(5661);
function textFormatter() {
    var _a;
    const defaultFormatter = fallbackFormatter((0, jsonEscaper_1.jsonEscaper)());
    try {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const util = __webpack_require__(3335);
        return (_a = util.format) !== null && _a !== void 0 ? _a : defaultFormatter;
    }
    catch (_b) {
        return defaultFormatter;
    }
}
exports.textFormatter = textFormatter;
function fallbackFormatter(jsonEscapeFunction) {
    return function fallbackFormatter(...params) {
        let result = '';
        for (const param of params) {
            result += typeof param === 'object' ? JSON.stringify(param, jsonEscapeFunction) : param === null || param === void 0 ? void 0 : param.toString();
        }
        return result;
    };
}
//# sourceMappingURL=textFormatter.js.map

/***/ }),

/***/ 6334:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OverwritingArray = void 0;
const OverwritingArrayIterator_1 = __webpack_require__(4257);
class OverwritingArray {
    constructor(capacity) {
        this.capacity = capacity;
        this._index = 0;
        this._size = 0;
        this._startIndex = 0;
        this._array = this.createArray();
    }
    add(value) {
        this._array[this._index] = value;
        this._index = this.incrementIndex(this._index);
        this._startIndex = this.incrementStartingIndex();
        this._size = this.incrementSize();
        return this;
    }
    clear() {
        this._array = this.createArray();
    }
    values() {
        return new OverwritingArrayIterator_1.OverwritingArrayIterator(this._array, this._startIndex, this._size);
    }
    [Symbol.iterator]() {
        return new OverwritingArrayIterator_1.OverwritingArrayIterator(this._array, this._startIndex, this._size);
    }
    incrementIndex(index) {
        return (index + 1) % this.capacity;
    }
    incrementStartingIndex() {
        if (this._size !== this.capacity) {
            return this._startIndex;
        }
        return this.incrementIndex(this._startIndex);
    }
    incrementSize() {
        return Math.min(this.capacity, this._size + 1);
    }
    createArray() {
        return new Array(this.capacity);
    }
}
exports.OverwritingArray = OverwritingArray;
//# sourceMappingURL=OverwritingArray.js.map

/***/ }),

/***/ 4257:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OverwritingArrayIterator = void 0;
class OverwritingArrayIterator {
    constructor(_source, _offset, _size) {
        this._source = _source;
        this._offset = _offset;
        this._size = _size;
    }
    [Symbol.iterator]() {
        return new OverwritingArrayIterator(this._source, this._offset, this._size);
    }
    next() {
        if (this._size === 0) {
            return {
                done: true,
                value: undefined,
            };
        }
        if (this._index === undefined) {
            this._index = 0;
        }
        else if (this._index === this._size - 1) {
            return {
                done: true,
                value: undefined,
            };
        }
        else {
            this._index++;
        }
        return {
            done: false,
            value: this._source[(this._index + this._offset) % this._size],
        };
    }
}
exports.OverwritingArrayIterator = OverwritingArrayIterator;
//# sourceMappingURL=OverwritingArrayIterator.js.map

/***/ }),

/***/ 2863:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(7605), exports);
__exportStar(__webpack_require__(5776), exports);
__exportStar(__webpack_require__(1403), exports);
__exportStar(__webpack_require__(3591), exports);
__exportStar(__webpack_require__(4691), exports);
__exportStar(__webpack_require__(5661), exports);
__exportStar(__webpack_require__(2910), exports);
__exportStar(__webpack_require__(35), exports);
__exportStar(__webpack_require__(36), exports);
__exportStar(__webpack_require__(8981), exports);
__exportStar(__webpack_require__(3697), exports);
__exportStar(__webpack_require__(5864), exports);
__exportStar(__webpack_require__(492), exports);
__exportStar(__webpack_require__(7945), exports);
__exportStar(__webpack_require__(6753), exports);
__exportStar(__webpack_require__(6075), exports);
__exportStar(__webpack_require__(3252), exports);
__exportStar(__webpack_require__(3065), exports);
__exportStar(__webpack_require__(5818), exports);
__exportStar(__webpack_require__(4650), exports);
__exportStar(__webpack_require__(1612), exports);
__exportStar(__webpack_require__(6298), exports);
__exportStar(__webpack_require__(524), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9942:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceAttachment.js.map

/***/ }),

/***/ 8108:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceFileAttachment.js.map

/***/ }),

/***/ 8456:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceStringAttachment = void 0;
class BacktraceStringAttachment {
    constructor(name, data) {
        this.name = name;
        this.data = data;
    }
    get() {
        return this.data;
    }
}
exports.BacktraceStringAttachment = BacktraceStringAttachment;
//# sourceMappingURL=BacktraceStringAttachment.js.map

/***/ }),

/***/ 8279:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceUint8ArrayAttachment = void 0;
class BacktraceUint8ArrayAttachment {
    constructor(name, data) {
        this.name = name;
        this.data = data;
    }
    get() {
        return new Blob([this.data.buffer]);
    }
}
exports.BacktraceUint8ArrayAttachment = BacktraceUint8ArrayAttachment;
//# sourceMappingURL=BacktraceUint8ArrayAttachment.js.map

/***/ }),

/***/ 2910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(9942), exports);
__exportStar(__webpack_require__(8108), exports);
__exportStar(__webpack_require__(8456), exports);
__exportStar(__webpack_require__(8279), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 35:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceConfiguration.js.map

/***/ }),

/***/ 36:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceDatabaseConfiguration.js.map

/***/ }),

/***/ 6283:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceData.js.map

/***/ }),

/***/ 9334:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceStackTrace.js.map

/***/ }),

/***/ 8634:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=JavaScriptEngine.js.map

/***/ }),

/***/ 8981:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(6283), exports);
__exportStar(__webpack_require__(9334), exports);
__exportStar(__webpack_require__(8634), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4543:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceReportSubmission = void 0;
const jsonEscaper_1 = __webpack_require__(5661);
const SubmissionUrlInformation_1 = __webpack_require__(6012);
class BacktraceReportSubmission {
    constructor(options, _requestHandler) {
        this._requestHandler = _requestHandler;
        this._submissionUrl = SubmissionUrlInformation_1.SubmissionUrlInformation.toJsonReportSubmissionUrl(options.url, options.token);
    }
    send(data, attachments) {
        const json = JSON.stringify(data, (0, jsonEscaper_1.jsonEscaper)());
        return this._requestHandler.postError(this._submissionUrl, json, attachments);
    }
}
exports.BacktraceReportSubmission = BacktraceReportSubmission;
//# sourceMappingURL=BacktraceReportSubmission.js.map

/***/ }),

/***/ 3117:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DEFAULT_TIMEOUT = void 0;
exports.DEFAULT_TIMEOUT = 15000;
//# sourceMappingURL=BacktraceRequestHandler.js.map

/***/ }),

/***/ 6012:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SubmissionUrlInformation = void 0;
class SubmissionUrlInformation {
    /**
     * Convert url/token from credentials to JSON submission URL
     * @param url credentials URL
     * @param token credentials token
     * @returns JSON submissionURL
     */
    static toJsonReportSubmissionUrl(url, token) {
        // if the token doesn't exist - use URL
        if (!token) {
            return url;
        }
        // if the url points to submit, we should always use it without any modifications
        if (url.includes(this.SUBMIT_PREFIX)) {
            return url;
        }
        // if the URL has token in the URL, the user probably added a token once again
        // in this case, don't do anything
        if (url.indexOf(token) !== -1) {
            return url;
        }
        const result = new URL(`/post`, url);
        result.searchParams.append('format', 'json');
        result.searchParams.append('token', token);
        return result.href;
    }
    /**
     * Converts full submission JSON URL to PlCrashReporter submission URL
     * @param submissionUrl Backtrace Submission URL
     */
    static toPlCrashReporterSubmissionUrl(submissionUrl) {
        return this.changeSubmissionFormat(submissionUrl, 'plcrash');
    }
    /**
     * Converts full submission JSON URL to minidump submission URL
     * @param submissionUrl Backtrace Submission URL
     */
    static toMinidumpSubmissionUrl(submissionUrl) {
        return this.changeSubmissionFormat(submissionUrl, 'minidump');
    }
    /**
     * Find the universe based on the submission URL
     * @param submissionUrl submission URL - full submission URL to Backtrace.
     * @returns universe name
     */
    static findUniverse(submissionUrl) {
        const submitIndex = submissionUrl.indexOf(this.SUBMIT_PREFIX);
        if (submitIndex !== -1) {
            // submit format URL
            // submit.backtrace.io/universe/token/format
            // we can expect the universe name just after the hostname
            const universeStartIndex = submitIndex + this.SUBMIT_PREFIX.length;
            const endOfUniverseName = submissionUrl.indexOf('/', universeStartIndex);
            return submissionUrl.substring(universeStartIndex, endOfUniverseName);
        }
        // the universe name should be available in the hostname
        // for example abc.sp.backtrace.io or zyx.in.backtrace.io or foo.backtrace.io
        const domainIndex = submissionUrl.indexOf('.backtrace.io');
        if (domainIndex === -1) {
            return undefined;
        }
        const protocolSeparator = '://';
        let protocolEndIndex = submissionUrl.indexOf(protocolSeparator);
        if (protocolEndIndex === -1) {
            protocolEndIndex = 0;
        }
        else {
            protocolEndIndex += protocolSeparator.length;
        }
        const hostname = submissionUrl.substring(protocolEndIndex, domainIndex);
        const endOfUniverseName = hostname.indexOf('.');
        return endOfUniverseName === -1 ? hostname : hostname.substring(0, endOfUniverseName);
    }
    static findToken(submissionUrl) {
        var _a;
        const submitIndex = submissionUrl.indexOf(this.SUBMIT_PREFIX);
        if (submitIndex !== -1) {
            const submissionUrlParts = submissionUrl.split('/');
            // submit format URL
            // submit.backtrace.io/universe/token/format
            // by spliting the submission URL by `/` and dropping the last
            // part of the URL, the last element on the list is the token.
            return (_a = submissionUrlParts[submissionUrlParts.length - 2]) !== null && _a !== void 0 ? _a : null;
        }
        const url = new URL(submissionUrl);
        return url.searchParams.get('token');
    }
    static changeSubmissionFormat(submissionUrl, desiredFormat) {
        const submitIndex = submissionUrl.indexOf(this.SUBMIT_PREFIX);
        if (submitIndex !== -1) {
            const queryParametersIndex = submissionUrl.indexOf('?');
            const queryParameters = queryParametersIndex === -1 ? '' : submissionUrl.substring(queryParametersIndex);
            const pathname = submissionUrl.substring(submitIndex + this.SUBMIT_PREFIX.length, queryParametersIndex === -1 ? undefined : queryParametersIndex);
            const pathParts = pathname.split('/');
            // path parts are prefixed with '/' character. Expected and valid submit format is:
            // /universe/token/format
            // splitting pathname should generate at least 4 elements ('', universe, token, format)
            // if pathParts length is not equal to 4 then the invalid were passed.
            const expectedMinimalPathParts = 3;
            if (pathParts.length < expectedMinimalPathParts) {
                return submissionUrl;
            }
            pathParts[2] = desiredFormat;
            return (submissionUrl.substring(0, submitIndex + this.SUBMIT_PREFIX.length) +
                pathParts.join('/') +
                queryParameters);
        }
        else {
            const url = new URL(submissionUrl);
            url.searchParams.set('format', desiredFormat);
            return url.href;
        }
    }
}
exports.SubmissionUrlInformation = SubmissionUrlInformation;
SubmissionUrlInformation.SUBMIT_PREFIX = 'submit.backtrace.io/';
//# sourceMappingURL=SubmissionUrlInformation.js.map

/***/ }),

/***/ 739:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConnectionError = void 0;
class ConnectionError {
    /**
     * Verifies if an Error is a connection error
     * @param err error
     * @returns true if the error was caused by ETIMEDOUT or ECONNRESET or ECONNABORTED
     */
    static isConnectionError(err) {
        const error = err;
        return error.code === 'ETIMEDOUT' || error.code === 'ECONNRESET' || error.code === 'ECONNABORTED';
    }
}
exports.ConnectionError = ConnectionError;
//# sourceMappingURL=ConnectionError.js.map

/***/ }),

/***/ 3697:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(3117), exports);
__exportStar(__webpack_require__(739), exports);
__exportStar(__webpack_require__(2473), exports);
__exportStar(__webpack_require__(2895), exports);
__exportStar(__webpack_require__(2138), exports);
__exportStar(__webpack_require__(6012), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2473:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceSubmissionResponse.js.map

/***/ }),

/***/ 2895:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceReportSubmissionResult = void 0;
class BacktraceReportSubmissionResult {
    get result() {
        return this._result;
    }
    constructor(statusOrResponse, message) {
        this.message = message;
        this.status = 'Ok';
        if (this.isSubmissionResponse(statusOrResponse)) {
            this.status = statusOrResponse;
            return;
        }
        this._result = statusOrResponse;
    }
    static OnLimitReached() {
        return new BacktraceReportSubmissionResult('Limit reached', 'Client report limit reached');
    }
    static OnInternalServerError(message) {
        return new BacktraceReportSubmissionResult('Server Error', message);
    }
    static OnInvalidToken() {
        return new BacktraceReportSubmissionResult('Invalid token');
    }
    static OnUnknownError(message) {
        return new BacktraceReportSubmissionResult('Unknown', message);
    }
    static OnNetworkingError(message) {
        return new BacktraceReportSubmissionResult('Network Error', message);
    }
    static Ok(response) {
        return new BacktraceReportSubmissionResult(response);
    }
    isSubmissionResponse(statusOrResponse) {
        return typeof statusOrResponse === 'string';
    }
}
exports.BacktraceReportSubmissionResult = BacktraceReportSubmissionResult;
//# sourceMappingURL=BacktraceSubmissionResult.js.map

/***/ }),

/***/ 2138:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceSubmissionStatus.js.map

/***/ }),

/***/ 5864:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceErrorType.js.map

/***/ }),

/***/ 492:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceReport = void 0;
const jsonEscaper_1 = __webpack_require__(5661);
const TimeHelper_1 = __webpack_require__(4691);
class BacktraceReport {
    addStackTrace(name, stack, message = '') {
        if (typeof stack === 'string') {
            this.stackTrace[name] = {
                stack,
                message,
            };
        }
        else {
            this.stackTrace[name] = stack;
        }
        return this;
    }
    constructor(data, attributes = {}, attachments = [], options = {}) {
        var _a, _b, _c;
        this.data = data;
        this.attributes = attributes;
        this.attachments = attachments;
        /**
         * Report classifiers
         */
        this.classifiers = [];
        /**
         * Report annotations
         */
        this.annotations = {};
        /**
         * Report stack trace
         */
        this.stackTrace = {};
        /**
         * Report inner errors
         */
        this.innerReport = [];
        /**
         * Report timestamp in ms
         */
        this.timestamp = TimeHelper_1.TimeHelper.now();
        /**
         * Sets how many top frames should be skipped.
         */
        this.skipFrames = 0;
        this.skipFrames = (_a = options === null || options === void 0 ? void 0 : options.skipFrames) !== null && _a !== void 0 ? _a : 0;
        let errorType = 'Exception';
        if (data instanceof Error) {
            this.message = this.generateErrorMessage(data.message);
            this.annotations['error'] = Object.assign(Object.assign({}, data), { message: this.message, name: data.name, stack: data.stack });
            this.classifiers = [data.name];
            this.stackTrace['main'] = {
                stack: (_b = data.stack) !== null && _b !== void 0 ? _b : '',
                message: this.message,
            };
            // Supported in ES2022
            if (data.cause) {
                this.innerReport.push(data.cause);
            }
        }
        else {
            this.message = this.generateErrorMessage(data);
            this.stackTrace['main'] = {
                stack: (_c = new Error().stack) !== null && _c !== void 0 ? _c : '',
                message: this.message,
            };
            this.classifiers = ['Message'];
            errorType = 'Message';
            this.skipFrames += 1;
        }
        if (!this.attributes['error.type']) {
            this.attributes['error.type'] = errorType;
        }
        this.attributes['error.message'] = this.message;
        if (options === null || options === void 0 ? void 0 : options.timestamp) {
            this.timestamp = options.timestamp;
        }
        if (options === null || options === void 0 ? void 0 : options.classifiers) {
            this.classifiers.unshift(...options.classifiers);
        }
    }
    generateErrorMessage(data) {
        var _a;
        return typeof data === 'object' ? JSON.stringify(data, (0, jsonEscaper_1.jsonEscaper)()) : (_a = data === null || data === void 0 ? void 0 : data.toString()) !== null && _a !== void 0 ? _a : '';
    }
}
exports.BacktraceReport = BacktraceReport;
//# sourceMappingURL=BacktraceReport.js.map

/***/ }),

/***/ 8240:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AttributeManager = void 0;
const Events_1 = __webpack_require__(3286);
const ReportDataBuilder_1 = __webpack_require__(6041);
class AttributeManager {
    constructor(providers) {
        this._attributeProviders = [];
        this.attributeEvents = new Events_1.Events();
        for (const provider of providers) {
            this.addProvider(provider);
        }
    }
    /**
     * Adds attributes to manager cache
     * @param attributes attributes object
     */
    add(attributes) {
        if (typeof attributes === 'function') {
            this.addProvider({ type: 'dynamic', get: attributes });
        }
        else {
            this.addProvider({ type: 'scoped', get: () => attributes });
        }
    }
    /**
     * Adds attribute provider to the manager
     * @param attributeProvider
     * @returns
     */
    addProvider(attributeProvider) {
        if (attributeProvider.type === 'dynamic') {
            this._attributeProviders.push(attributeProvider);
            return;
        }
        else {
            const attributes = attributeProvider.get();
            this._attributeProviders.push({
                type: 'scoped',
                get: () => attributes,
            });
            this.attributeEvents.emit('scoped-attributes-updated', this.get('scoped'));
        }
    }
    /**
     * Gets client attributes
     * @returns Report attribute - client attributes and annotations
     */
    get(attributeType) {
        const result = {
            annotations: {},
            attributes: {},
        };
        for (const attributeProvider of this._attributeProviders) {
            if (attributeType && attributeProvider.type != attributeType) {
                continue;
            }
            const providerResult = ReportDataBuilder_1.ReportDataBuilder.build(attributeProvider.get());
            result.attributes = Object.assign(Object.assign({}, result.attributes), providerResult.attributes);
            result.annotations = Object.assign(Object.assign({}, result.annotations), providerResult.annotations);
        }
        return result;
    }
}
exports.AttributeManager = AttributeManager;
//# sourceMappingURL=AttributeManager.js.map

/***/ }),

/***/ 6753:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceAttributeProvider.js.map

/***/ }),

/***/ 6743:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClientAttributeProvider = void 0;
class ClientAttributeProvider {
    constructor(_sdkName, _sdkVersion, _sessionId) {
        this._sdkName = _sdkName;
        this._sdkVersion = _sdkVersion;
        this._sessionId = _sessionId;
    }
    get type() {
        return 'scoped';
    }
    get() {
        return {
            'application.session': this._sessionId,
            'backtrace.agent': this._sdkName,
            'backtrace.version': this._sdkVersion,
        };
    }
}
exports.ClientAttributeProvider = ClientAttributeProvider;
//# sourceMappingURL=ClientAttributeProvider.js.map

/***/ }),

/***/ 5275:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FileAttributeManager = void 0;
const jsonEscaper_1 = __webpack_require__(5661);
const ATTRIBUTE_FILE_NAME = 'bt-attributes';
class FileAttributeManager {
    constructor(_fileSystem, _fileName) {
        this._fileSystem = _fileSystem;
        this._fileName = _fileName;
    }
    static create(fileSystem) {
        return new FileAttributeManager(fileSystem);
    }
    static createFromSession(sessionFiles, fileSystem) {
        const fileName = sessionFiles.getFileName(ATTRIBUTE_FILE_NAME);
        return new FileAttributeManager(fileSystem, fileName);
    }
    initialize() {
        this.saveAttributes();
    }
    bind({ attributeManager, sessionFiles }) {
        if (this._fileName) {
            throw new Error('This instance is already bound.');
        }
        if (!sessionFiles) {
            return;
        }
        this._fileName = sessionFiles.getFileName(ATTRIBUTE_FILE_NAME);
        this._attributeManager = attributeManager;
        attributeManager.attributeEvents.on('scoped-attributes-updated', () => this.saveAttributes());
    }
    dispose() {
        this._fileName = undefined;
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._fileName) {
                return {};
            }
            try {
                const content = yield this._fileSystem.readFile(this._fileName);
                return JSON.parse(content);
            }
            catch (_a) {
                return {};
            }
        });
    }
    saveAttributes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._fileName || !this._attributeManager) {
                return;
            }
            const reportData = this._attributeManager.get('scoped');
            yield this._fileSystem.writeFile(this._fileName, JSON.stringify(reportData.attributes, (0, jsonEscaper_1.jsonEscaper)()));
        });
    }
}
exports.FileAttributeManager = FileAttributeManager;
//# sourceMappingURL=FileAttributeManager.js.map

/***/ }),

/***/ 6041:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ReportDataBuilder = void 0;
class ReportDataBuilder {
    static build(attributes) {
        const result = { annotations: {}, attributes: {} };
        if (!attributes) {
            return result;
        }
        for (const attributeKey in attributes) {
            const attribute = attributes[attributeKey];
            if (attribute == null) {
                result.attributes[attributeKey] = attribute;
                continue;
            }
            switch (typeof attribute) {
                case 'object': {
                    result.annotations[attributeKey] = attribute;
                    break;
                }
                case 'bigint': {
                    result.attributes[attributeKey] = attribute.toString();
                    break;
                }
                default: {
                    result.attributes[attributeKey] = attribute;
                    break;
                }
            }
        }
        return result;
    }
}
exports.ReportDataBuilder = ReportDataBuilder;
//# sourceMappingURL=ReportDataBuilder.js.map

/***/ }),

/***/ 8094:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UserAttributeProvider = void 0;
class UserAttributeProvider {
    constructor(source) {
        this._source = typeof source === 'function' ? source : () => source;
        this.type = typeof source === 'function' ? 'dynamic' : 'scoped';
    }
    get() {
        return this._source();
    }
}
exports.UserAttributeProvider = UserAttributeProvider;
//# sourceMappingURL=UserAttributeProvider.js.map

/***/ }),

/***/ 7945:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(5275), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2430:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceBreadcrumbs.js.map

/***/ }),

/***/ 6576:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BreadcrumbsManager = void 0;
const _1 = __webpack_require__(6075);
const ConsoleEventSubscriber_1 = __webpack_require__(3147);
const InMemoryBreadcrumbsStorage_1 = __webpack_require__(4855);
const BREADCRUMB_ATTRIBUTE_NAME = 'breadcrumbs.lastId';
class BreadcrumbsManager {
    constructor(configuration, options) {
        var _a, _b, _c;
        /**
         * Determines if the breadcrumb manager is enabled.
         */
        this._enabled = true;
        this._eventSubscribers = [new ConsoleEventSubscriber_1.ConsoleEventSubscriber()];
        this.breadcrumbsType = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.eventType) !== null && _a !== void 0 ? _a : _1.defaultBreadcurmbType;
        this.logLevel = (_b = configuration === null || configuration === void 0 ? void 0 : configuration.logLevel) !== null && _b !== void 0 ? _b : _1.defaultBreadcrumbsLogLevel;
        this._storage = (_c = options === null || options === void 0 ? void 0 : options.storage) !== null && _c !== void 0 ? _c : new InMemoryBreadcrumbsStorage_1.InMemoryBreadcrumbsStorage(configuration === null || configuration === void 0 ? void 0 : configuration.maximumBreadcrumbs);
        this._interceptor = configuration === null || configuration === void 0 ? void 0 : configuration.intercept;
        if (options === null || options === void 0 ? void 0 : options.subscribers) {
            this._eventSubscribers.push(...options.subscribers);
        }
    }
    setStorage(storage) {
        this._storage = storage;
    }
    dispose() {
        this._enabled = false;
        for (const subscriber of this._eventSubscribers) {
            subscriber.dispose();
        }
    }
    bind({ client, reportEvents }) {
        for (const attachment of this._storage.getAttachments()) {
            client.addAttachment(attachment);
        }
        client.addAttribute(() => ({
            [BREADCRUMB_ATTRIBUTE_NAME]: this._storage.lastBreadcrumbId,
        }));
        reportEvents.on('before-skip', (report) => this.logReport(report));
    }
    initialize() {
        for (const subscriber of this._eventSubscribers) {
            subscriber.start(this);
        }
    }
    verbose(message, attributes) {
        return this.log(message, _1.BreadcrumbLogLevel.Verbose, attributes);
    }
    debug(message, attributes) {
        return this.log(message, _1.BreadcrumbLogLevel.Debug, attributes);
    }
    info(message, attributes) {
        return this.log(message, _1.BreadcrumbLogLevel.Info, attributes);
    }
    warn(message, attributes) {
        return this.log(message, _1.BreadcrumbLogLevel.Warning, attributes);
    }
    error(message, attributes) {
        return this.log(message, _1.BreadcrumbLogLevel.Error, attributes);
    }
    log(message, level, attributes) {
        return this.addBreadcrumb(message, level, _1.BreadcrumbType.Manual, attributes);
    }
    logReport(report) {
        const level = report.data instanceof Error ? _1.BreadcrumbLogLevel.Error : _1.BreadcrumbLogLevel.Warning;
        return this.addBreadcrumb(report.message, level, _1.BreadcrumbType.System);
    }
    addBreadcrumb(message, level, type, attributes) {
        if (!this._enabled) {
            return false;
        }
        let rawBreadcrumb = {
            message,
            level,
            type,
            attributes,
        };
        if (this._interceptor) {
            const interceptorBreadcrumb = this._interceptor(rawBreadcrumb);
            if (!interceptorBreadcrumb) {
                return false;
            }
            rawBreadcrumb = interceptorBreadcrumb;
        }
        if ((this.logLevel & rawBreadcrumb.level) !== level) {
            return false;
        }
        if ((this.breadcrumbsType & rawBreadcrumb.type) !== type) {
            return false;
        }
        this._storage.add(rawBreadcrumb);
        return true;
    }
}
exports.BreadcrumbsManager = BreadcrumbsManager;
//# sourceMappingURL=BreadcrumbsManager.js.map

/***/ }),

/***/ 1907:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BreadcrumbsSetup.js.map

/***/ }),

/***/ 9509:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BreadcrurmbsEventSubscriber.js.map

/***/ }),

/***/ 3147:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConsoleEventSubscriber = void 0;
const textFormatter_1 = __webpack_require__(439);
const BreadcrumbLogLevel_1 = __webpack_require__(6006);
const BreadcrumbType_1 = __webpack_require__(4446);
class ConsoleEventSubscriber {
    constructor() {
        /**
         * All overriden console events
         */
        this._events = {};
    }
    start(breadcrumbsManager) {
        if ((breadcrumbsManager.breadcrumbsType & BreadcrumbType_1.BreadcrumbType.Log) !== BreadcrumbType_1.BreadcrumbType.Log) {
            return;
        }
        this._formatter = (0, textFormatter_1.textFormatter)();
        this.bindToConsoleMethod('log', BreadcrumbLogLevel_1.BreadcrumbLogLevel.Info, breadcrumbsManager);
        this.bindToConsoleMethod('warn', BreadcrumbLogLevel_1.BreadcrumbLogLevel.Warning, breadcrumbsManager);
        this.bindToConsoleMethod('error', BreadcrumbLogLevel_1.BreadcrumbLogLevel.Error, breadcrumbsManager);
        this.bindToConsoleMethod('debug', BreadcrumbLogLevel_1.BreadcrumbLogLevel.Debug, breadcrumbsManager);
        this.bindToConsoleMethod('trace', BreadcrumbLogLevel_1.BreadcrumbLogLevel.Verbose, breadcrumbsManager);
    }
    dispose() {
        for (const key in this._events) {
            const consoleMethod = this._events[key];
            console[key] = consoleMethod;
        }
    }
    bindToConsoleMethod(name, level, breadcrumbsManager) {
        const originalMethod = console[name];
        console[name] = (...args) => {
            originalMethod(...args);
            const message = this._formatter(...args);
            breadcrumbsManager.addBreadcrumb(message, level, BreadcrumbType_1.BreadcrumbType.Log);
        };
        this._events[name] = originalMethod;
    }
}
exports.ConsoleEventSubscriber = ConsoleEventSubscriber;
//# sourceMappingURL=ConsoleEventSubscriber.js.map

/***/ }),

/***/ 6075:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(2430), exports);
__exportStar(__webpack_require__(6576), exports);
__exportStar(__webpack_require__(1907), exports);
__exportStar(__webpack_require__(9509), exports);
__exportStar(__webpack_require__(3292), exports);
__exportStar(__webpack_require__(6006), exports);
__exportStar(__webpack_require__(4446), exports);
__exportStar(__webpack_require__(9595), exports);
__exportStar(__webpack_require__(4376), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3292:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=Breadcrumb.js.map

/***/ }),

/***/ 6006:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultBreadcrumbsLogLevel = exports.BreadcrumbLogLevel = void 0;
var BreadcrumbLogLevel;
(function (BreadcrumbLogLevel) {
    BreadcrumbLogLevel[BreadcrumbLogLevel["Verbose"] = 1] = "Verbose";
    BreadcrumbLogLevel[BreadcrumbLogLevel["Debug"] = 2] = "Debug";
    BreadcrumbLogLevel[BreadcrumbLogLevel["Info"] = 4] = "Info";
    BreadcrumbLogLevel[BreadcrumbLogLevel["Warning"] = 8] = "Warning";
    BreadcrumbLogLevel[BreadcrumbLogLevel["Error"] = 16] = "Error";
})(BreadcrumbLogLevel || (exports.BreadcrumbLogLevel = BreadcrumbLogLevel = {}));
exports.defaultBreadcrumbsLogLevel = (1 << 5) - 1;
//# sourceMappingURL=BreadcrumbLogLevel.js.map

/***/ }),

/***/ 4446:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultBreadcurmbType = exports.BreadcrumbType = void 0;
var BreadcrumbType;
(function (BreadcrumbType) {
    BreadcrumbType[BreadcrumbType["Manual"] = 1] = "Manual";
    BreadcrumbType[BreadcrumbType["Log"] = 2] = "Log";
    BreadcrumbType[BreadcrumbType["Navigation"] = 4] = "Navigation";
    BreadcrumbType[BreadcrumbType["Http"] = 8] = "Http";
    BreadcrumbType[BreadcrumbType["System"] = 16] = "System";
    BreadcrumbType[BreadcrumbType["User"] = 32] = "User";
    BreadcrumbType[BreadcrumbType["Configuration"] = 64] = "Configuration";
})(BreadcrumbType || (exports.BreadcrumbType = BreadcrumbType = {}));
exports.defaultBreadcurmbType = (1 << 7) - 1;
//# sourceMappingURL=BreadcrumbType.js.map

/***/ }),

/***/ 9595:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=RawBreadcrumb.js.map

/***/ }),

/***/ 4376:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BreadcrumbsStorage.js.map

/***/ }),

/***/ 4855:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InMemoryBreadcrumbsStorage = void 0;
const jsonEscaper_1 = __webpack_require__(5661);
const TimeHelper_1 = __webpack_require__(4691);
const OverwritingArray_1 = __webpack_require__(6334);
const BreadcrumbLogLevel_1 = __webpack_require__(6006);
const BreadcrumbType_1 = __webpack_require__(4446);
class InMemoryBreadcrumbsStorage {
    get lastBreadcrumbId() {
        return this._lastBreadcrumbId;
    }
    constructor(maximumBreadcrumbs = 100) {
        /**
         * Breadcrumb name
         */
        this.name = 'bt-breadcrumbs-0';
        this._lastBreadcrumbId = TimeHelper_1.TimeHelper.toTimestampInSec(TimeHelper_1.TimeHelper.now());
        this._breadcrumbs = new OverwritingArray_1.OverwritingArray(maximumBreadcrumbs);
    }
    getAttachments() {
        return [this];
    }
    /**
     * Returns breadcrumbs in the JSON format
     * @returns Breadcrumbs JSON
     */
    get() {
        return JSON.stringify([...this._breadcrumbs.values()], (0, jsonEscaper_1.jsonEscaper)());
    }
    add(rawBreadcrumb) {
        this._lastBreadcrumbId++;
        const id = this._lastBreadcrumbId;
        const breadcrumb = {
            id,
            message: rawBreadcrumb.message,
            timestamp: TimeHelper_1.TimeHelper.now(),
            type: BreadcrumbType_1.BreadcrumbType[rawBreadcrumb.type].toLowerCase(),
            level: BreadcrumbLogLevel_1.BreadcrumbLogLevel[rawBreadcrumb.level].toLowerCase(),
        };
        if (rawBreadcrumb.attributes) {
            breadcrumb.attributes = rawBreadcrumb.attributes;
        }
        this._breadcrumbs.add(breadcrumb);
        return id;
    }
}
exports.InMemoryBreadcrumbsStorage = InMemoryBreadcrumbsStorage;
//# sourceMappingURL=InMemoryBreadcrumbsStorage.js.map

/***/ }),

/***/ 3036:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceStackTraceConverter.js.map

/***/ }),

/***/ 3065:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V8StackTraceConverter = void 0;
const frameNamesConsts_1 = __webpack_require__(3552);
class V8StackTraceConverter {
    get engine() {
        return 'v8';
    }
    convert(stackTrace, message) {
        const result = [];
        let stackFrames = stackTrace.split('\n');
        const errorHeader = message.split('\n');
        // remove error header from stack trace - if the error header exists
        if (stackFrames[0].indexOf(errorHeader[0]) !== -1) {
            stackFrames = stackFrames.slice(errorHeader.length);
        }
        else {
            stackFrames = stackFrames.slice(1);
        }
        for (const stackFrame of stackFrames) {
            const normalizedStackFrame = stackFrame.trim();
            if (!normalizedStackFrame) {
                continue;
            }
            const frame = this.parseFrame(normalizedStackFrame);
            result.push(frame);
        }
        return result;
    }
    parseFrame(stackFrame) {
        const frameSeparator = 'at ';
        if (!stackFrame.startsWith(frameSeparator)) {
            return {
                funcName: stackFrame,
                library: frameNamesConsts_1.UNKNOWN_FRAME,
            };
        }
        stackFrame = stackFrame.substring(stackFrame.indexOf(frameSeparator) + frameSeparator.length);
        const sourceCodeSeparator = ' (';
        const sourceCodeStartIndex = stackFrame.indexOf(sourceCodeSeparator);
        const anonymousFunction = sourceCodeStartIndex === -1;
        if (anonymousFunction) {
            return Object.assign({ funcName: frameNamesConsts_1.ANONYMOUS_FUNCTION }, this.parseSourceCodeInformation(stackFrame));
        }
        return Object.assign({ funcName: stackFrame.substring(0, sourceCodeStartIndex) }, this.parseSourceCodeInformation(stackFrame.substring(sourceCodeStartIndex + sourceCodeSeparator.length, stackFrame.length - 1)));
    }
    parseSourceCodeInformation(sourceCodeInformation) {
        if (sourceCodeInformation.startsWith('eval')) {
            return this.extractEvalInformation(sourceCodeInformation);
        }
        const sourceCodeParts = sourceCodeInformation.split(':');
        const column = parseInt(sourceCodeParts[sourceCodeParts.length - 1]);
        const lineNumber = parseInt(sourceCodeParts[sourceCodeParts.length - 2]);
        const library = sourceCodeParts.slice(0, sourceCodeParts.length - 2).join(':');
        return {
            library,
            column: isNaN(column) ? undefined : column,
            line: isNaN(lineNumber) ? undefined : lineNumber,
        };
    }
    extractEvalInformation(evalSourceCodeInformation) {
        const sourceCodeStartSeparatorChar = '(';
        const sourceCodeEndSeparatorChar = ')';
        const sourceCodeStart = evalSourceCodeInformation.indexOf(sourceCodeStartSeparatorChar);
        const sourceCodeEnd = evalSourceCodeInformation.indexOf(sourceCodeEndSeparatorChar);
        if (sourceCodeStart === -1 || sourceCodeEnd === -1 || sourceCodeStart > sourceCodeEnd) {
            return {
                library: frameNamesConsts_1.UNKNOWN_FRAME,
            };
        }
        const sourceCodeInformation = evalSourceCodeInformation.substring(sourceCodeStart + sourceCodeStartSeparatorChar.length, sourceCodeEnd);
        return this.parseSourceCodeInformation(sourceCodeInformation);
    }
}
exports.V8StackTraceConverter = V8StackTraceConverter;
//# sourceMappingURL=V8StackTraceConverter.js.map

/***/ }),

/***/ 3552:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ANONYMOUS_FUNCTION = exports.UNKNOWN_FRAME = void 0;
exports.UNKNOWN_FRAME = 'unknown';
exports.ANONYMOUS_FUNCTION = 'anonymous';
//# sourceMappingURL=frameNamesConsts.js.map

/***/ }),

/***/ 3252:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(3036), exports);
__exportStar(__webpack_require__(3552), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4350:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceDataBuilder = void 0;
const IdGenerator_1 = __webpack_require__(3591);
const TimeHelper_1 = __webpack_require__(4691);
const ReportDataBuilder_1 = __webpack_require__(6041);
class BacktraceDataBuilder {
    constructor(_sdkOptions, _stackTraceConverter, _attributeManager, _debugIdProvider) {
        this._sdkOptions = _sdkOptions;
        this._stackTraceConverter = _stackTraceConverter;
        this._attributeManager = _attributeManager;
        this._debugIdProvider = _debugIdProvider;
        this.MAIN_THREAD_NAME = 'main';
    }
    build(report) {
        const { annotations, attributes } = this._attributeManager.get();
        const reportData = ReportDataBuilder_1.ReportDataBuilder.build(report.attributes);
        const { threads, detectedDebugIdentifier } = this.getThreads(report);
        const result = {
            uuid: IdGenerator_1.IdGenerator.uuid(),
            timestamp: TimeHelper_1.TimeHelper.toTimestampInSec(report.timestamp),
            agent: this._sdkOptions.agent,
            agentVersion: this._sdkOptions.agentVersion,
            lang: this._sdkOptions.langName,
            langVersion: this._sdkOptions.langVersion,
            classifiers: report.classifiers,
            mainThread: this.MAIN_THREAD_NAME,
            threads,
            annotations: Object.assign(Object.assign(Object.assign({}, annotations), reportData.annotations), report.annotations),
            attributes: Object.assign(Object.assign({}, attributes), reportData.attributes),
        };
        if (detectedDebugIdentifier) {
            result.symbolication = 'sourcemap';
        }
        return result;
    }
    getThreads(report) {
        const threads = {};
        let detectedDebugIdentifier = false;
        for (const [name, traceInfo] of Object.entries(report.stackTrace)) {
            let stackFrames;
            if (Array.isArray(traceInfo)) {
                stackFrames = traceInfo;
            }
            else {
                const { message, stack } = traceInfo;
                stackFrames = this._stackTraceConverter.convert(stack, message);
            }
            if (name === this.MAIN_THREAD_NAME && report.skipFrames > 0) {
                stackFrames.splice(0, report.skipFrames);
            }
            for (const frame of stackFrames) {
                const debugIdentifier = this._debugIdProvider.getDebugId(frame.library);
                if (!debugIdentifier) {
                    continue;
                }
                detectedDebugIdentifier = true;
                frame.debug_identifier = debugIdentifier;
            }
            threads[name] = {
                fault: name === this.MAIN_THREAD_NAME,
                name,
                stack: stackFrames,
            };
        }
        return {
            threads,
            detectedDebugIdentifier,
        };
    }
}
exports.BacktraceDataBuilder = BacktraceDataBuilder;
//# sourceMappingURL=BacktraceDataBuilder.js.map

/***/ }),

/***/ 2674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceDatabase = void 0;
const IdGenerator_1 = __webpack_require__(3591);
const TimeHelper_1 = __webpack_require__(4691);
const BacktraceDatabaseContext_1 = __webpack_require__(2246);
class BacktraceDatabase {
    /**
     * Determines if the database is enabled.
     */
    get enabled() {
        return this._enabled;
    }
    constructor(_options, _storageProvider, _requestHandler, _sessionFiles) {
        var _a, _b, _c, _d, _e;
        this._options = _options;
        this._storageProvider = _storageProvider;
        this._requestHandler = _requestHandler;
        this._sessionFiles = _sessionFiles;
        this._storageProviders = [];
        this._enabled = false;
        this._databaseRecordContext = new BacktraceDatabaseContext_1.BacktraceDatabaseContext((_a = this._options) === null || _a === void 0 ? void 0 : _a.maximumRetries);
        this._maximumRecords = (_c = (_b = this._options) === null || _b === void 0 ? void 0 : _b.maximumNumberOfRecords) !== null && _c !== void 0 ? _c : 8;
        this._retryInterval = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.retryInterval) !== null && _e !== void 0 ? _e : 60000;
    }
    /**
     * Starts database integration.
     * @returns true if the database started successfully. Otherwise false.
     */
    initialize() {
        var _a, _b;
        if (this._enabled) {
            return this._enabled;
        }
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.enable) === false) {
            return false;
        }
        const startResult = this._storageProvider.start();
        if (!startResult) {
            return false;
        }
        const lockId = (_b = this._sessionFiles) === null || _b === void 0 ? void 0 : _b.lockPreviousSessions();
        this.loadReports()
            .then(() => {
            this.setupDatabaseAutoSend();
        })
            .finally(() => { var _a; return lockId && ((_a = this._sessionFiles) === null || _a === void 0 ? void 0 : _a.unlockPreviousSessions(lockId)); });
        this._enabled = true;
        return true;
    }
    bind({ reportEvents }) {
        var _a;
        if (this._enabled) {
            return;
        }
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.enable) === false) {
            return;
        }
        reportEvents.on('before-send', (_, data, attachments) => {
            const record = this.add(data, attachments);
            if (!record || record.locked || record.count !== 1) {
                return undefined;
            }
            record.locked = true;
        });
        reportEvents.on('after-send', (_, data, __, submissionResult) => {
            var _a;
            const record = this._databaseRecordContext.find((record) => record.data.uuid === data.uuid);
            if (!record) {
                return;
            }
            record.locked = false;
            if (submissionResult.status === 'Ok') {
                this.remove(record);
                (_a = this._sessionFiles) === null || _a === void 0 ? void 0 : _a.unlockPreviousSessions(record.id);
            }
        });
    }
    /**
     * Adds backtrace data to the database
     * @param backtraceData diagnostic data object
     * @param attachments attachments
     * @returns record if database is enabled. Otherwise undefined.
     */
    add(backtraceData, attachments) {
        if (!this._enabled) {
            return undefined;
        }
        this.prepareDatabase();
        const record = {
            count: 1,
            data: backtraceData,
            timestamp: TimeHelper_1.TimeHelper.now(),
            hash: '',
            id: IdGenerator_1.IdGenerator.uuid(),
            locked: false,
            attachments: attachments,
        };
        const saveResult = this._storageProvider.add(record);
        if (!saveResult) {
            return undefined;
        }
        this._databaseRecordContext.add(record);
        this.lockSessionWithRecord(record);
        return record;
    }
    /**
     * Returns stored references to Backtrace records
     * @returns available records in the database
     */
    get() {
        return this._databaseRecordContext.get();
    }
    /**
     * @returns Returns number of records stored in the Database
     */
    count() {
        return this._databaseRecordContext.count();
    }
    /**
     * Disables database integration. After running the dispose method, you cannot
     * execute any database operations.
     */
    dispose() {
        this._enabled = false;
        clearInterval(this._intervalId);
    }
    /**
     * Removes the database record
     * @param record database records
     */
    remove(record) {
        var _a;
        if (!this._enabled) {
            return;
        }
        this._databaseRecordContext.remove(record);
        this._storageProvider.delete(record);
        (_a = this._sessionFiles) === null || _a === void 0 ? void 0 : _a.unlockPreviousSessions(record.id);
    }
    addStorageProvider(storageProvider) {
        if (this._enabled) {
            throw new Error('Cannot add storage provider after the database has been enabled.');
        }
        this._storageProviders.push(storageProvider);
    }
    /**
     * Sends all records available in the database to Backtrace and removes them
     * no matter if the submission process was successful or not.
     */
    flush() {
        return __awaiter(this, void 0, void 0, function* () {
            const start = TimeHelper_1.TimeHelper.now();
            yield this.send();
            const records = this.get().filter((n) => n.timestamp <= start);
            for (const record of records) {
                this.remove(record);
            }
        });
    }
    /**
     * Sends all records available in the database to Backtrace.
     */
    send() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let bucketIndex = 0; bucketIndex < this._databaseRecordContext.bucketCount; bucketIndex++) {
                for (const record of this._databaseRecordContext.getBucket(bucketIndex)) {
                    if (record.locked) {
                        continue;
                    }
                    try {
                        record.locked = true;
                        const result = yield this._requestHandler.send(record.data, record.attachments);
                        if (result.status === 'Ok') {
                            this.remove(record);
                            continue;
                        }
                        this._databaseRecordContext.increaseBucket(bucketIndex);
                        return;
                    }
                    finally {
                        record.locked = false;
                    }
                }
            }
        });
    }
    /**
     * Prepare database to insert records
     * @param totalNumberOfRecords number of records to insert
     */
    prepareDatabase(totalNumberOfRecords = 1) {
        const numberOfRecords = this.count();
        if (numberOfRecords + totalNumberOfRecords <= this._maximumRecords) {
            return;
        }
        const recordsToDelete = this._databaseRecordContext.dropOverflow(totalNumberOfRecords);
        for (const record of recordsToDelete) {
            this._storageProvider.delete(record);
        }
    }
    loadReports() {
        return __awaiter(this, void 0, void 0, function* () {
            const records = yield this._storageProvider.get();
            if (records.length > this._maximumRecords) {
                records.length = this._maximumRecords;
            }
            this.prepareDatabase(records.length);
            this._databaseRecordContext.load(records);
            for (const record of records) {
                this.lockSessionWithRecord(record);
            }
        });
    }
    setupDatabaseAutoSend() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.autoSend) === false) {
                return;
            }
            const sendDatabaseReports = () => __awaiter(this, void 0, void 0, function* () {
                yield this.send();
            });
            this._intervalId = setInterval(sendDatabaseReports, this._retryInterval);
            yield this.send();
        });
    }
    lockSessionWithRecord(record) {
        var _a;
        if (!this._sessionFiles) {
            return;
        }
        const sessionId = (_a = record.data.attributes) === null || _a === void 0 ? void 0 : _a['application.session'];
        if (typeof sessionId !== 'string') {
            this._sessionFiles.lockPreviousSessions(record.id);
            return;
        }
        const session = this._sessionFiles.getSessionWithId(sessionId);
        session === null || session === void 0 ? void 0 : session.lock(record.id);
    }
}
exports.BacktraceDatabase = BacktraceDatabase;
//# sourceMappingURL=BacktraceDatabase.js.map

/***/ }),

/***/ 2246:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceDatabaseContext = void 0;
class BacktraceDatabaseContext {
    constructor(bucketCount = 3) {
        this.bucketCount = bucketCount;
        this.recordBucket = this.setupRecordBucket(this.bucketCount);
    }
    find(predicate) {
        for (let index = 0; index < this.bucketCount; index++) {
            for (const record of this.recordBucket[index]) {
                if (predicate(record)) {
                    return record;
                }
            }
        }
        return undefined;
    }
    add(record) {
        this.recordBucket[0].push(record);
    }
    get() {
        const result = [];
        for (const bucket of this.recordBucket) {
            result.push(...bucket.map((n) => {
                return Object.assign({}, n);
            }));
        }
        return result;
    }
    getBucket(index) {
        return this.recordBucket[index];
    }
    count() {
        return Object.values(this.recordBucket)
            .map((n) => n.reduce((total, record) => total + record.count, 0))
            .reduce((total, current) => total + current, 0);
    }
    remove(databaseRecord) {
        for (let bucketIndex = 0; bucketIndex < this.bucketCount; bucketIndex++) {
            for (let recordIndex = 0; recordIndex < this.recordBucket[bucketIndex].length; recordIndex++) {
                const record = this.recordBucket[bucketIndex][recordIndex];
                if (databaseRecord.id === record.id) {
                    this.recordBucket[bucketIndex].splice(recordIndex, 1);
                    return;
                }
            }
        }
    }
    increaseBucket(bucketStart) {
        for (let bucketIndex = this.bucketCount - 1; bucketIndex >= bucketStart; bucketIndex--) {
            if (bucketIndex === this.bucketCount - 1) {
                this.recordBucket[bucketIndex] = [];
                continue;
            }
            this.recordBucket[bucketIndex + 1] = this.recordBucket[bucketIndex];
            this.recordBucket[bucketIndex] = [];
        }
    }
    load(records) {
        this.recordBucket[0].push(...records);
    }
    dropOverflow(overflow) {
        const result = [];
        for (let bucketIndex = this.bucketCount - 1; bucketIndex >= 0; bucketIndex--) {
            const bucket = this.recordBucket[bucketIndex];
            const removedRecords = bucket.splice(0, overflow);
            result.push(...removedRecords);
            if (result.length === overflow) {
                break;
            }
        }
        return result;
    }
    setupRecordBucket(retries) {
        const result = [];
        for (let index = 0; index < retries; index++) {
            result[index] = [];
        }
        return result;
    }
}
exports.BacktraceDatabaseContext = BacktraceDatabaseContext;
//# sourceMappingURL=BacktraceDatabaseContext.js.map

/***/ }),

/***/ 2167:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceDatabaseFileRecord = void 0;
class BacktraceDatabaseFileRecord {
    constructor(record, attachments) {
        this.attachments = attachments;
        this.data = record.data;
        this.id = record.id;
        this.count = record.count;
        this.hash = record.hash;
        this.timestamp = record.timestamp;
        // make sure the database record stored in the database directory
        // is never locked. By doing this, we want to be sure once we load
        // the record once again, the record will be available for future usage
        this.locked = false;
    }
    static fromRecord(record) {
        return new BacktraceDatabaseFileRecord(record, record.attachments.filter(BacktraceDatabaseFileRecord.isFileAttachment));
    }
    static fromJson(json, fileSystem) {
        try {
            const record = JSON.parse(json);
            const attachments = record.attachments
                ? record.attachments
                    .filter(BacktraceDatabaseFileRecord.isFileAttachment)
                    .map((n) => fileSystem.createAttachment(n.filePath, n.name))
                : [];
            return new BacktraceDatabaseFileRecord(record, attachments);
        }
        catch (_a) {
            return undefined;
        }
    }
    static isFileAttachment(attachment) {
        return 'filePath' in attachment && typeof attachment.filePath === 'string';
    }
}
exports.BacktraceDatabaseFileRecord = BacktraceDatabaseFileRecord;
//# sourceMappingURL=BacktraceDatabaseFileRecord.js.map

/***/ }),

/***/ 96:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceDatabaseFileStorageProvider = void 0;
const jsonEscaper_1 = __webpack_require__(5661);
const BacktraceDatabaseFileRecord_1 = __webpack_require__(2167);
class BacktraceDatabaseFileStorageProvider {
    constructor(_fileSystem, _path) {
        this._fileSystem = _fileSystem;
        this._path = _path;
        this._enabled = true;
        this.RECORD_SUFFIX = '-record.json';
    }
    /**
     * Create a provider if provided options are valid
     * @param options database configuration
     * @returns database file storage provider
     */
    static createIfValid(fileSystem, options) {
        if (!options) {
            return undefined;
        }
        if (!options.enable) {
            return undefined;
        }
        if (options.enable && !options.path) {
            throw new Error('Missing mandatory path to the database. Please define the database.path option in the configuration.');
        }
        return new BacktraceDatabaseFileStorageProvider(fileSystem, options.path);
    }
    start() {
        // make sure by mistake we don't create anything or start any operation
        if (this._enabled === false) {
            return false;
        }
        return true;
    }
    delete(record) {
        const recordPath = this.getRecordPath(record.id);
        return this.unlinkRecord(recordPath);
    }
    add(record) {
        const recordPath = this.getRecordPath(record.id);
        try {
            this._fileSystem.writeFileSync(recordPath, JSON.stringify(BacktraceDatabaseFileRecord_1.BacktraceDatabaseFileRecord.fromRecord(record), (0, jsonEscaper_1.jsonEscaper)()));
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            const databaseFiles = yield this._fileSystem.readDir(this._path);
            const recordNames = databaseFiles
                .filter((file) => file.endsWith(this.RECORD_SUFFIX))
                .map((f) => this._path + '/' + f);
            const records = [];
            for (const recordName of recordNames) {
                try {
                    const recordJson = yield this._fileSystem.readFile(recordName);
                    const record = BacktraceDatabaseFileRecord_1.BacktraceDatabaseFileRecord.fromJson(recordJson, this._fileSystem);
                    if (!record) {
                        yield this._fileSystem.unlink(recordName);
                        continue;
                    }
                    records.push(record);
                }
                catch (_a) {
                    yield this._fileSystem.unlink(recordName);
                }
            }
            return records;
        });
    }
    unlinkRecord(recordPath) {
        if (!this._fileSystem.existsSync(recordPath)) {
            return false;
        }
        try {
            this._fileSystem.unlinkSync(recordPath);
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    getRecordPath(id) {
        return this._path + '/' + `${id}${this.RECORD_SUFFIX}`;
    }
}
exports.BacktraceDatabaseFileStorageProvider = BacktraceDatabaseFileStorageProvider;
//# sourceMappingURL=BacktraceDatabaseFileStorageProvider.js.map

/***/ }),

/***/ 456:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceDatabaseStorageProvider.js.map

/***/ }),

/***/ 5818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(456), exports);
__exportStar(__webpack_require__(2826), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2826:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceDatabaseRecord.js.map

/***/ }),

/***/ 9923:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BacktraceMetrics = void 0;
const TimeHelper_1 = __webpack_require__(4691);
const ReportDataBuilder_1 = __webpack_require__(6041);
const SummedEvent_1 = __webpack_require__(1898);
const UniqueEvent_1 = __webpack_require__(160);
class BacktraceMetrics {
    /**
     * Returns current session id.
     */
    get sessionId() {
        return this._sessionProvider.sessionId;
    }
    constructor(_options, _sessionProvider, _attributeManager, _summedEventsSubmissionQueue, _uniqueEventsSubmissionQueue) {
        var _a, _b;
        this._options = _options;
        this._sessionProvider = _sessionProvider;
        this._attributeManager = _attributeManager;
        this._summedEventsSubmissionQueue = _summedEventsSubmissionQueue;
        this._uniqueEventsSubmissionQueue = _uniqueEventsSubmissionQueue;
        /**
         * Default metrics submission interval. The variable defines how often metrics will be sent to metrics system.
         */
        this.DEFAULT_UPDATE_INTERVAL = TimeHelper_1.TimeHelper.convertSecondsToMilliseconds(30 * 60);
        this.DEFAULT_SERVER_URL = 'https://events.backtrace.io';
        this.metricsHost = (_a = this._options.metricsSubmissionUrl) !== null && _a !== void 0 ? _a : this.DEFAULT_SERVER_URL;
        this._updateInterval = (_b = this._options.autoSendInterval) !== null && _b !== void 0 ? _b : this.DEFAULT_UPDATE_INTERVAL;
    }
    /**
     * Starts metrics submission.
     */
    initialize() {
        if (!this._sessionProvider.newSession) {
            return;
        }
        this.addSummedEvent('Application Launches');
        this.send();
        if (this._updateInterval === 0) {
            return;
        }
        this._updateIntervalId = setInterval(() => {
            this.send();
        }, this._updateInterval);
    }
    /**
     * Returns total number of events in the submission queue.
     */
    count() {
        var _a, _b, _c, _d;
        return (_d = (_b = (_a = this._summedEventsSubmissionQueue) === null || _a === void 0 ? void 0 : _a.total) !== null && _b !== void 0 ? _b : 0 + ((_c = this._uniqueEventsSubmissionQueue) === null || _c === void 0 ? void 0 : _c.total)) !== null && _d !== void 0 ? _d : 0;
    }
    /**
     * Add summed event to next Backtrace Metrics request.
     * @param metricName Summed event name.
     * @param eventAttributes event attributes.
     */
    addSummedEvent(metricName, eventAttributes = {}) {
        if (!metricName) {
            return false;
        }
        const attributes = this.convertAttributes(Object.assign(Object.assign({}, this._attributeManager.get().attributes), ReportDataBuilder_1.ReportDataBuilder.build(eventAttributes !== null && eventAttributes !== void 0 ? eventAttributes : {}).attributes));
        this._summedEventsSubmissionQueue.add(new SummedEvent_1.SummedEvent(metricName, attributes));
        return true;
    }
    /**
     * Sends event to the metrics system.
     */
    send() {
        if (!this._sessionProvider.shouldSend()) {
            return false;
        }
        this.sendUniqueEvent();
        this._summedEventsSubmissionQueue.send();
        this._sessionProvider.afterMetricsSubmission();
        return true;
    }
    /**
     * Cleans up metrics interface.
     */
    dispose() {
        if (this._updateIntervalId) {
            clearInterval(this._updateIntervalId);
        }
    }
    sendUniqueEvent() {
        // always add the same unique event before send.
        const { attributes } = this._attributeManager.get();
        this._uniqueEventsSubmissionQueue.add(new UniqueEvent_1.UniqueEvent(this.convertAttributes(attributes)));
        this._uniqueEventsSubmissionQueue.send();
    }
    /**
     * Event aggregators expecting to retrieve attributes in a string format. They also
     * don't expect to retrieve null/undefined as attribute values.
     */
    convertAttributes(attributes) {
        return Object.keys(attributes)
            .filter((n) => attributes[n] != null)
            .reduce((acc, n) => {
            var _a;
            acc[n] = (_a = attributes[n]) === null || _a === void 0 ? void 0 : _a.toString();
            return acc;
        }, {});
    }
}
exports.BacktraceMetrics = BacktraceMetrics;
//# sourceMappingURL=BacktraceMetrics.js.map

/***/ }),

/***/ 4650:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=BacktraceSessionProvider.js.map

/***/ }),

/***/ 5666:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MetricsBuilder = void 0;
const TimeHelper_1 = __webpack_require__(4691);
const BacktraceMetrics_1 = __webpack_require__(9923);
const MetricsSubmissionQueue_1 = __webpack_require__(176);
const MetricsUrlInformation_1 = __webpack_require__(7317);
class MetricsBuilder {
    constructor(_options, _sessionProvider, _attributeManager, _requestHandler) {
        this._options = _options;
        this._sessionProvider = _sessionProvider;
        this._attributeManager = _attributeManager;
        this._requestHandler = _requestHandler;
        /**
         * Default metrics submission interval. The variable defines how often metrics will be sent to metrics system
         * By default 30 mins.
         */
        this.DEFAULT_UPDATE_INTERVAL = TimeHelper_1.TimeHelper.convertSecondsToMilliseconds(30 * 60);
        this.APPLICATION_VERSION_ATTRIBUTE = 'application.version';
        this.APPLICATION_ATTRIBUTE = 'application';
    }
    build(uniqueEventsSubmissionQueue, summedEventsSubmissionQueue) {
        var _a;
        const metricsOptions = Object.assign(Object.assign({}, this.optionsWithDefaults()), ((_a = this._options.metrics) !== null && _a !== void 0 ? _a : {}));
        if (!metricsOptions.enable) {
            return undefined;
        }
        const applicationInfo = this.verifyAttributeSetup();
        if (!applicationInfo) {
            return undefined;
        }
        uniqueEventsSubmissionQueue =
            uniqueEventsSubmissionQueue !== null && uniqueEventsSubmissionQueue !== void 0 ? uniqueEventsSubmissionQueue : this.createUniqueEventSubmissionQueue(metricsOptions.metricsSubmissionUrl, applicationInfo);
        if (!uniqueEventsSubmissionQueue) {
            return undefined;
        }
        summedEventsSubmissionQueue =
            summedEventsSubmissionQueue !== null && summedEventsSubmissionQueue !== void 0 ? summedEventsSubmissionQueue : this.createSummedEventSubmissionQueue(metricsOptions.metricsSubmissionUrl, applicationInfo);
        if (!summedEventsSubmissionQueue) {
            return undefined;
        }
        return new BacktraceMetrics_1.BacktraceMetrics(metricsOptions, this._sessionProvider, this._attributeManager, summedEventsSubmissionQueue, uniqueEventsSubmissionQueue);
    }
    verifyAttributeSetup() {
        const { attributes } = this._attributeManager.get();
        const application = attributes[this.APPLICATION_ATTRIBUTE];
        const applicationVersion = attributes[this.APPLICATION_VERSION_ATTRIBUTE];
        if (!application || !applicationVersion) {
            return undefined;
        }
        return { application, applicationVersion };
    }
    createUniqueEventSubmissionQueue(metricsHost, applicationInfo) {
        var _a, _b;
        const uniqueEventsSubmissionUrl = MetricsUrlInformation_1.MetricsUrlInformation.generateUniqueEventsUrl(metricsHost, this._options.url, this._options.token);
        if (!uniqueEventsSubmissionUrl) {
            return undefined;
        }
        return new MetricsSubmissionQueue_1.MetricsSubmissionQueue(uniqueEventsSubmissionUrl, 'unique_events', this._requestHandler, {
            [this.APPLICATION_ATTRIBUTE]: applicationInfo.application,
            appversion: applicationInfo.applicationVersion,
        }, (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.metrics) === null || _b === void 0 ? void 0 : _b.size);
    }
    createSummedEventSubmissionQueue(metricsHost, applicationInfo) {
        var _a, _b;
        const summedEventsSubmissionUrl = MetricsUrlInformation_1.MetricsUrlInformation.generateSummedEventsUrl(metricsHost, this._options.url, this._options.token);
        if (!summedEventsSubmissionUrl) {
            return undefined;
        }
        return new MetricsSubmissionQueue_1.MetricsSubmissionQueue(summedEventsSubmissionUrl, 'summed_events', this._requestHandler, {
            [this.APPLICATION_ATTRIBUTE]: applicationInfo.application,
            appversion: applicationInfo.applicationVersion,
        }, (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.metrics) === null || _b === void 0 ? void 0 : _b.size);
    }
    optionsWithDefaults() {
        return {
            enable: true,
            autoSendInterval: this.DEFAULT_UPDATE_INTERVAL,
            metricsSubmissionUrl: 'https://events.backtrace.io',
            size: 50,
        };
    }
}
exports.MetricsBuilder = MetricsBuilder;
//# sourceMappingURL=MetricsBuilder.js.map

/***/ }),

/***/ 176:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MetricsSubmissionQueue = void 0;
const DelayHelper_1 = __webpack_require__(4815);
const jsonEscaper_1 = __webpack_require__(5661);
const TimeHelper_1 = __webpack_require__(4691);
class MetricsSubmissionQueue {
    get total() {
        return this._events.length;
    }
    get submissionUrl() {
        return this._submissionUrl;
    }
    constructor(_submissionUrl, _eventName, _requestHandler, _metricMetadata, maximumEvents = 50) {
        this._submissionUrl = _submissionUrl;
        this._eventName = _eventName;
        this._requestHandler = _requestHandler;
        this._metricMetadata = _metricMetadata;
        this.maximumEvents = maximumEvents;
        this.DELAY_BETWEEN_REQUESTS = TimeHelper_1.TimeHelper.convertSecondsToMilliseconds(10);
        this._events = [];
        this._numberOfDroppedRequests = 0;
        this.MAXIMUM_NUMBER_OF_ATTEMPTS = 3;
    }
    add(event) {
        this._events.push(event);
        if (this.reachedLimit()) {
            this.send();
        }
    }
    send() {
        return __awaiter(this, void 0, void 0, function* () {
            const eventsToProcess = this._events.splice(0);
            return yield this.submit(eventsToProcess);
        });
    }
    submit(events) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let attempts = 0; attempts < this.MAXIMUM_NUMBER_OF_ATTEMPTS; attempts++) {
                const response = yield this._requestHandler.post(this._submissionUrl, JSON.stringify(Object.assign(Object.assign({}, this._metricMetadata), { [this._eventName]: events, metadata: {
                        dropped_events: this._numberOfDroppedRequests,
                    } }), (0, jsonEscaper_1.jsonEscaper)()));
                if (response.status === 'Ok') {
                    this._numberOfDroppedRequests = 0;
                    return;
                }
                this._numberOfDroppedRequests++;
                yield DelayHelper_1.Delay.wait(Math.pow(2, attempts) * this.DELAY_BETWEEN_REQUESTS);
            }
            // if the code reached this line, it means, we couldn't send data to server
            // we need to try to return events to the queue and try to send it once again later.
            this.returnEventsIfPossible(events);
        });
    }
    returnEventsIfPossible(events) {
        if (this.maximumEvents < this._events.length + events.length) {
            return;
        }
        // push events to the beginning of the queue
        this._events.unshift(...events);
    }
    reachedLimit() {
        return this.maximumEvents === this._events.length && this.maximumEvents !== 0;
    }
}
exports.MetricsSubmissionQueue = MetricsSubmissionQueue;
//# sourceMappingURL=MetricsSubmissionQueue.js.map

/***/ }),

/***/ 7317:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MetricsUrlInformation = void 0;
const http_1 = __webpack_require__(3697);
class MetricsUrlInformation {
    static generateSummedEventsUrl(hostname, submissionUrl, credentialsToken) {
        const submissionInformation = this.findSubmissionInformation(submissionUrl, credentialsToken);
        if (!submissionInformation) {
            return undefined;
        }
        return this.generateEventsServiceUrl(hostname, 'summed-events', submissionInformation.universe, submissionInformation.token);
    }
    static generateUniqueEventsUrl(hostname, submissionUrl, credentialsToken) {
        const submissionInformation = this.findSubmissionInformation(submissionUrl, credentialsToken);
        if (!submissionInformation) {
            return undefined;
        }
        return this.generateEventsServiceUrl(hostname, 'unique-events', submissionInformation.universe, submissionInformation.token);
    }
    static generateEventsServiceUrl(hostname, eventServiceName, universe, token) {
        return new URL(`/api/${eventServiceName}/submit?universe=${universe}&token=${token}`, hostname).toString();
    }
    static findSubmissionInformation(submissionUrl, token) {
        const universe = http_1.SubmissionUrlInformation.findUniverse(submissionUrl);
        if (!universe) {
            return undefined;
        }
        token = token !== null && token !== void 0 ? token : http_1.SubmissionUrlInformation.findToken(submissionUrl);
        if (!token) {
            return undefined;
        }
        return { universe, token };
    }
}
exports.MetricsUrlInformation = MetricsUrlInformation;
//# sourceMappingURL=MetricsUrlInformation.js.map

/***/ }),

/***/ 1612:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SingleSessionProvider = void 0;
const IdGenerator_1 = __webpack_require__(3591);
const TimeHelper_1 = __webpack_require__(4691);
class SingleSessionProvider {
    constructor() {
        this.newSession = true;
        this.sessionId = IdGenerator_1.IdGenerator.uuid();
        this._lastActive = 0;
    }
    get lastActive() {
        return this._lastActive;
    }
    afterMetricsSubmission() {
        this._lastActive = TimeHelper_1.TimeHelper.now();
    }
    /**
     * Allow to alway send metrics - in the single session there is no reason
     * to skip sending metrics.
     */
    shouldSend() {
        return true;
    }
}
exports.SingleSessionProvider = SingleSessionProvider;
//# sourceMappingURL=SingleSessionProvider.js.map

/***/ }),

/***/ 6056:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MetricsEvent = void 0;
const IdGenerator_1 = __webpack_require__(3591);
const TimeHelper_1 = __webpack_require__(4691);
class MetricsEvent {
    constructor(metricGroupName, metricGroupValue, attributes = {}) {
        this.metricGroupName = metricGroupName;
        this.metricGroupValue = metricGroupValue;
        this.attributes = attributes;
        this.id = IdGenerator_1.IdGenerator.uuid();
    }
    toJSON() {
        return {
            timestamp: TimeHelper_1.TimeHelper.toTimestampInSec(TimeHelper_1.TimeHelper.now()),
            attributes: this.attributes,
            [this.metricGroupName]: this.metricGroupValue,
        };
    }
}
exports.MetricsEvent = MetricsEvent;
//# sourceMappingURL=MetricsEvent.js.map

/***/ }),

/***/ 1898:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SummedEvent = void 0;
const MetricsEvent_1 = __webpack_require__(6056);
class SummedEvent extends MetricsEvent_1.MetricsEvent {
    constructor(metricGroupName, attributes = {}) {
        super('metric_group', metricGroupName, attributes);
    }
}
exports.SummedEvent = SummedEvent;
//# sourceMappingURL=SummedEvent.js.map

/***/ }),

/***/ 160:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UniqueEvent = void 0;
const MetricsEvent_1 = __webpack_require__(6056);
class UniqueEvent extends MetricsEvent_1.MetricsEvent {
    constructor(attributes) {
        super('unique', ['guid'], attributes);
    }
}
exports.UniqueEvent = UniqueEvent;
//# sourceMappingURL=UniqueEvent.js.map

/***/ }),

/***/ 1533:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RateLimitWatcher = void 0;
const TimeHelper_1 = __webpack_require__(4691);
class RateLimitWatcher {
    get enabled() {
        return this._watcherEnable;
    }
    constructor(reportPerMin) {
        /**
         * Time the single report can stay in the queue in ms.
         */
        this.MAXIMUM_TIME_IN_QUEUE = 60 * 1000;
        this._reportQueue = [];
        if (reportPerMin == null) {
            reportPerMin = 0;
        }
        if (reportPerMin < 0) {
            throw new Error('ReportPerMinute argument must be greater or equal to zero');
        }
        this._reportPerMin = reportPerMin;
        this._watcherEnable = reportPerMin > 0;
    }
    skipReport() {
        const time = TimeHelper_1.TimeHelper.now();
        if (!this._watcherEnable) {
            return false;
        }
        this.clear(time);
        if (this._reportQueue.length >= this._reportPerMin) {
            return true;
        }
        this._reportQueue.push(time);
        return false;
    }
    clear(time) {
        if (this._reportQueue.length === 0) {
            return;
        }
        // we don't have anything to remove
        if (time - this._reportQueue[0] < this.MAXIMUM_TIME_IN_QUEUE) {
            return;
        }
        for (let queueIndex = this._reportQueue.length; queueIndex != 0; queueIndex--) {
            if (time - this._reportQueue[queueIndex - 1] > this.MAXIMUM_TIME_IN_QUEUE) {
                this._reportQueue = this._reportQueue.slice(queueIndex);
                return;
            }
        }
    }
}
exports.RateLimitWatcher = RateLimitWatcher;
//# sourceMappingURL=RateLimitWatcher.js.map

/***/ }),

/***/ 7695:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=FileSystem.js.map

/***/ }),

/***/ 3482:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SessionFiles = void 0;
const Events_1 = __webpack_require__(3286);
const IdGenerator_1 = __webpack_require__(3591);
const SESSION_MARKER_PREFIX = 'bt-session';
const isDefined = (t) => !!t;
class SessionFiles {
    constructor(_fileSystem, _directory, sessionId, _maxPreviousLockedSessions = 1, _timestamp = Date.now(), _lockable = true) {
        this._fileSystem = _fileSystem;
        this._directory = _directory;
        this.sessionId = sessionId;
        this._maxPreviousLockedSessions = _maxPreviousLockedSessions;
        this._timestamp = _timestamp;
        this._lockable = _lockable;
        this._events = new Events_1.Events();
        this._locks = new Set();
        this._cleared = false;
        this._escapedSessionId = this.escapeFileName(sessionId);
        this.marker = this.getFileName(SESSION_MARKER_PREFIX);
    }
    initialize() {
        this.createSessionMarker();
    }
    getPreviousSession() {
        if (this._previousSession) {
            return this._previousSession;
        }
        const directoryFiles = this.readDirectoryFiles();
        if (!directoryFiles.length) {
            return undefined;
        }
        const sessionMarkers = directoryFiles
            .filter((f) => f.startsWith(SESSION_MARKER_PREFIX))
            .map((f) => this.getFileSession(f))
            .filter(isDefined)
            .sort((a, b) => b.timestamp - a.timestamp);
        const currentSessionMarker = sessionMarkers.find((s) => s.sessionId === this.sessionId);
        const lastSessionMarker = currentSessionMarker
            ? sessionMarkers.filter(({ timestamp }) => currentSessionMarker.timestamp > timestamp)[0]
            : sessionMarkers[0];
        if (!lastSessionMarker) {
            return undefined;
        }
        return (this._previousSession = new SessionFiles(this._fileSystem, this._directory, lastSessionMarker.sessionId, this._maxPreviousLockedSessions - 1, lastSessionMarker.timestamp, this._maxPreviousLockedSessions > 0));
    }
    getSessionWithId(sessionId) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let session = this;
        while (session && session.sessionId !== sessionId) {
            session = session.getPreviousSession();
        }
        return session;
    }
    getPreviousSessions(count = Infinity) {
        const result = [];
        let current = this.getPreviousSession();
        while (current && count > 0) {
            result.push(current);
            count--;
            current = current.getPreviousSession();
        }
        return result;
    }
    lockPreviousSessions(lockId) {
        lockId = lockId !== null && lockId !== void 0 ? lockId : IdGenerator_1.IdGenerator.uuid();
        for (const session of this.getPreviousSessions(this._maxPreviousLockedSessions)) {
            session.lock(lockId);
        }
        return lockId;
    }
    unlockPreviousSessions(lockId) {
        for (const session of this.getPreviousSessions(this._maxPreviousLockedSessions)) {
            session.unlock(lockId);
        }
    }
    clearPreviousSessions() {
        for (const session of this.getPreviousSessions()) {
            session.clearSession();
        }
    }
    getFileName(prefix) {
        this.throwIfCleared();
        return this._directory + '/' + `${this.escapeFileName(prefix)}_${this._escapedSessionId}_${this._timestamp}`;
    }
    getSessionFiles() {
        this.throwIfCleared();
        const files = this.readDirectoryFiles();
        return files
            .map((file) => this.getFileSession(file))
            .filter(isDefined)
            .filter(({ sessionId }) => sessionId === this.sessionId)
            .map(({ file }) => this._directory + '/' + file);
    }
    clearSession() {
        if (this._locks.size > 0) {
            this._events.once('unlocked', () => this.clearSession());
            return;
        }
        if (this._cleared) {
            return;
        }
        try {
            const sessionFiles = this.getSessionFiles();
            for (const file of sessionFiles) {
                this._fileSystem.unlinkSync(file);
            }
        }
        catch (_a) {
            // Don't propagate errors
        }
        finally {
            this._cleared = true;
        }
    }
    lock(lockId) {
        if (this._cleared || !this._lockable) {
            return;
        }
        lockId = lockId !== null && lockId !== void 0 ? lockId : IdGenerator_1.IdGenerator.uuid();
        this._locks.add(lockId);
        return lockId;
    }
    unlock(lockId) {
        this._locks.delete(lockId);
        if (this._locks.size === 0) {
            this._events.emit('unlocked');
        }
    }
    getFileSession(file) {
        const [escapedSessionId, rawTimestamp] = this.splitByOneChar(file, '_').slice(-2);
        const timestamp = parseInt(rawTimestamp);
        if (isNaN(timestamp)) {
            return undefined;
        }
        return { file, escapedSessionId, timestamp, sessionId: this.unescapeFileName(escapedSessionId) };
    }
    readDirectoryFiles() {
        try {
            return this._fileSystem.readDirSync(this._directory);
        }
        catch (_a) {
            return [];
        }
    }
    createSessionMarker() {
        this._fileSystem.writeFileSync(this.marker, '');
    }
    escapeFileName(name) {
        return name.replace(/_/g, '__');
    }
    unescapeFileName(name) {
        return name.replace(/__/g, '_');
    }
    splitByOneChar(str, char) {
        const result = [];
        let start = 0;
        let index = str.indexOf(char);
        while (index !== -1) {
            if (str[index + 1] === char) {
                index = str.indexOf(char, index + 2);
            }
            else {
                result.push(str.substring(start, index));
                start = index + 1;
                index = str.indexOf(char, start);
            }
        }
        result.push(str.substring(start));
        return result;
    }
    throwIfCleared() {
        if (this._cleared) {
            throw new Error('This session files are cleared.');
        }
    }
}
exports.SessionFiles = SessionFiles;
//# sourceMappingURL=SessionFiles.js.map

/***/ }),

/***/ 6298:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(7695), exports);
__exportStar(__webpack_require__(3482), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 395:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DebugIdProvider = exports.SOURCE_DEBUG_ID_VARIABLE = void 0;
exports.SOURCE_DEBUG_ID_VARIABLE = '_btDebugIds';
class DebugIdProvider {
    constructor(_stackTraceConverter, _debugIdMapProvider) {
        this._stackTraceConverter = _stackTraceConverter;
        this._debugIdMapProvider = _debugIdMapProvider;
        this._fileDebugIds = this.loadDebugIds();
    }
    getDebugId(file) {
        const debugId = this._fileDebugIds[file];
        if (debugId) {
            return debugId;
        }
        // in case of dynamic require - lazy load dynamically debug ids
        this._fileDebugIds = this.loadDebugIds();
        return this._fileDebugIds[file];
    }
    loadDebugIds() {
        var _a;
        const debugIdMap = (_a = this._debugIdMapProvider) === null || _a === void 0 ? void 0 : _a.getDebugIdMap();
        if (!debugIdMap) {
            return {};
        }
        const message = new Error().message;
        const result = {};
        for (const [rawStack, debugId] of Object.entries(debugIdMap)) {
            const frames = this._stackTraceConverter.convert(rawStack, message);
            if (!frames.length) {
                continue;
            }
            // The first frame will have the file's path
            const frame = frames[0];
            result[frame.library] = debugId;
        }
        return result;
    }
}
exports.DebugIdProvider = DebugIdProvider;
//# sourceMappingURL=DebugIdProvider.js.map

/***/ }),

/***/ 2734:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VariableDebugIdMapProvider = void 0;
const DebugIdProvider_1 = __webpack_require__(395);
class VariableDebugIdMapProvider {
    constructor(_variable) {
        this._variable = _variable;
    }
    getDebugIdMap() {
        var _a;
        return (_a = this._variable[DebugIdProvider_1.SOURCE_DEBUG_ID_VARIABLE]) !== null && _a !== void 0 ? _a : {};
    }
}
exports.VariableDebugIdMapProvider = VariableDebugIdMapProvider;
//# sourceMappingURL=VariableDebugIdMapProvider.js.map

/***/ }),

/***/ 524:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(395), exports);
__exportStar(__webpack_require__(2734), exports);
__exportStar(__webpack_require__(4912), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4912:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=DebugIdMapProvider.js.map

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(1920);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map